/**
 * Copied from Veridas Schema and sorted alphabetically
 */
export const VERIDAS_IDV_SUPPORTED_DOCUMENTS = [
  "AD_DL",
  "AD_DrivingLicense_1990",
  "AD_DrivingLicense_2022",
  "AD_ID",
  "AD_ResidencePermit_2018",
  "AD",
  "AE_DL",
  "AE_DrivingLicense_1990",
  "AE_DrivingLicense_2005",
  "AE_DrivingLicense_YYYY",
  "AE_HC",
  "AE_HealthCard_YYYY",
  "AE_ID",
  "AE_IDCard_2011",
  "AE_IDCard_2021",
  "AE_IDCard_YYYY",
  "AE",
  "AF_DL",
  "AF_DrivingLicense_2019",
  "AF_DrivingLicense_YYYY",
  "AF_ID",
  "AF_IDCard_2018",
  "AF_IDCard_2022",
  "AF_IDCard_2023",
  "AF_IDCard_YYYY",
  "AF",
  "AG_DL",
  "AG_DrivingLicense_2021",
  "AG_DrivingLicense_YYYY",
  "AG_HC",
  "AG_HealthCard_YYYY",
  "AG_ID",
  "AG_IDCard_YYYY",
  "AG",
  "AI_DL",
  "AI_DrivingLicense_YYYY",
  "AI",
  "AL_DL",
  "AL_DrivingLicense_2010",
  "AL_DrivingLicense_2015",
  "AL_DrivingLicense_2017",
  "AL_ID",
  "AL_IDCard_2009",
  "AL_IDCard_2019",
  "AL_ResidencePermit_2021",
  "AL",
  "AM_DL",
  "AM_DrivingLicense_2005",
  "AM_DrivingLicense_2011",
  "AM_ID",
  "AM_IDCard_2012",
  "AM_ResidencePermit_2022",
  "AM_ResidencePermit_YYYY",
  "AM",
  "AO_DL",
  "AO_DrivingLicense_YYYY",
  "AO_HC",
  "AO_HealthCard_2007",
  "AO_ID",
  "AO_IDCard_2009",
  "AO_ResidencePermit_YYYY",
  "AO",
  "AR_DL",
  "AR_DrivingLicense_2010",
  "AR_DrivingLicense_2013",
  "AR_DrivingLicense_2017",
  "AR_DrivingLicense_YYYY",
  "AR_ID",
  "AR_IDCard_2009",
  "AR_IDCard_2012",
  "AR_IDCard_2019",
  "AR_IDCard_2020",
  "AR_IDCard_2023",
  "AR_IDCard_YYYY",
  "AR",
  "AR2_ID",
  "AR2",
  "ARG2009",
  "ARG2012",
  "AS_DL",
  "AS_DrivingLicense_2007",
  "AS_DrivingLicense_YYYY",
  "AS_DrivingLicense-PL_2007",
  "AS_ID",
  "AS_IDCard_YYYY",
  "AS",
  "AT_DL",
  "AT_DrivingLicense_1976",
  "AT_DrivingLicense_2004",
  "AT_DrivingLicense_2006",
  "AT_DrivingLicense_2012",
  "AT_DrivingLicense_2014",
  "AT_DrivingLicense_YYYY",
  "AT_HC",
  "AT_HealthCard_YYYY",
  "AT_ID",
  "AT_IDCard_2000",
  "AT_IDCard_2002",
  "AT_IDCard_2010",
  "AT_IDCard_2021",
  "AT_ResidencePermit_2003",
  "AT_ResidencePermit_2005",
  "AT_ResidencePermit_2011",
  "AT_ResidencePermit_2020",
  "AT",
  "AU_DL",
  "AU_HC",
  "AU_HealthCard_2024",
  "AU_HealthCard_YYYY",
  "AU_ID",
  "AU_PC",
  "AU_ResidencePermit_YYYY",
  "AU-ACT_DL",
  "AU-ACT_DrivingLicense_2011",
  "AU-ACT_DrivingLicense_YYYY",
  "AU-ACT_DrivingLicense-PL_YYYY",
  "AU-ACT_ID",
  "AU-ACT_PC",
  "AU-ACT_ProfessionalCard_YYYY",
  "AU-ACT",
  "AU-NSW_DL",
  "AU-NSW_DrivingLicense_2002",
  "AU-NSW_DrivingLicense_2013",
  "AU-NSW_DrivingLicense_YYYY",
  "AU-NSW_DrivingLicense-PL_2006",
  "AU-NSW_ID",
  "AU-NSW",
  "AU-NT_DL",
  "AU-NT_DrivingLicense_2006",
  "AU-NT_DrivingLicense_2020",
  "AU-NT_DrivingLicense_YYYY",
  "AU-NT_ID",
  "AU-NT",
  "AU-QLD_DL",
  "AU-QLD_DrivingLicense_1986",
  "AU-QLD_DrivingLicense_2011",
  "AU-QLD_DrivingLicense_2016",
  "AU-QLD_DrivingLicense_2019",
  "AU-QLD_DrivingLicense_2023",
  "AU-QLD_ID",
  "AU-QLD_IDCard_2019",
  "AU-QLD_IDCard_2023",
  "AU-QLD_PC",
  "AU-QLD_ProfessionalCard_YYYY",
  "AU-QLD",
  "AU-SA_DL",
  "AU-SA_DrivingLicense_2013",
  "AU-SA_DrivingLicense_2014",
  "AU-SA_DrivingLicense_YYYY",
  "AU-SA_DrivingLicense-PL_2013",
  "AU-SA_ID",
  "AU-SA",
  "AU-TAS_DL",
  "AU-TAS_DrivingLicense_2003",
  "AU-TAS_DrivingLicense_2015",
  "AU-TAS_DrivingLicense_2016",
  "AU-TAS_DrivingLicense-PL_2003",
  "AU-TAS_DrivingLicense-PL_2016",
  "AU-TAS_ID",
  "AU-TAS_PC",
  "AU-TAS_ProfessionalCard_YYYY",
  "AU-TAS",
  "AU-VIC_DL",
  "AU-VIC_DrivingLicense_2000",
  "AU-VIC_DrivingLicense_2009",
  "AU-VIC_DrivingLicense_YYYY",
  "AU-VIC_DrivingLicense-PL_2000",
  "AU-VIC_DrivingLicense-PL_2009",
  "AU-VIC_ID",
  "AU-VIC_PC",
  "AU-VIC_ProfessionalCard_YYYY",
  "AU-VIC",
  "AU-WA_DL",
  "AU-WA_DrivingLicense_1999",
  "AU-WA_DrivingLicense_2011",
  "AU-WA_DrivingLicense_2014",
  "AU-WA_DrivingLicense-PL_2011",
  "AU-WA_DrivingLicense-PL_2014",
  "AU-WA_ID",
  "AU-WA",
  "AU",
  "AW_DL",
  "AW_DrivingLicense_2003",
  "AW_DrivingLicense_2015",
  "AW_DrivingLicense_2020",
  "AW_ID",
  "AW_IDCard_2003",
  "AW_IDCard_2022",
  "AW_IDCard_YYYY",
  "AW_ResidencePermit-PL_YYYY",
  "AW",
  "AZ_DL",
  "AZ_DrivingLicense_2013",
  "AZ_DrivingLicense_2020",
  "AZ_DrivingLicense_YYYY",
  "AZ_HC",
  "AZ_HealthCard_2006",
  "AZ_ID",
  "AZ_IDCard_1998",
  "AZ_IDCard_2018",
  "AZ_ResidencePermit_YYYY",
  "AZ_ResidencePermit-PL_YYYY",
  "AZ",
  "BA_DL",
  "BA_DrivingLicense_2003",
  "BA_DrivingLicense_2013",
  "BA_DrivingLicense_2014",
  "BA_DrivingLicense_YYYY",
  "BA_ID",
  "BA_IDCard_2003",
  "BA_IDCard_2013",
  "BA",
  "BB_DL",
  "BB_DrivingLicense_YYYY",
  "BB_ID",
  "BB_IDCard_1979",
  "BB_IDCard_2022",
  "BB",
  "BD_DL",
  "BD_DrivingLicense_2000",
  "BD_DrivingLicense_2011",
  "BD_DrivingLicense_YYYY",
  "BD_ID",
  "BD_IDCard_2008",
  "BD_IDCard_2015",
  "BD_IDCard-PL_2008",
  "BD",
  "BE_DL",
  "BE_DrivingLicense_1989",
  "BE_DrivingLicense_1995",
  "BE_DrivingLicense_1998",
  "BE_DrivingLicense_2010",
  "BE_DrivingLicense_2013",
  "BE_DrivingLicense_2019",
  "BE_DrivingLicense-PL_2013",
  "BE_DrivingLicense-PL_2019",
  "BE_HC",
  "BE_HealthCard_YYYY",
  "BE_ID",
  "BE_IDCard_1996",
  "BE_IDCard_2000",
  "BE_IDCard_2003",
  "BE_IDCard_2008",
  "BE_IDCard_2010",
  "BE_IDCard_2020",
  "BE_IDCard_2021",
  "BE_IDCard_YYYY",
  "BE_ResidencePermit_1984",
  "BE_ResidencePermit_2007",
  "BE_ResidencePermit_2008",
  "BE_ResidencePermit_2013",
  "BE_ResidencePermit_2021",
  "BE_ResidencePermit_2022",
  "BE_ResidencePermit_2024",
  "BE",
  "BF_DL",
  "BF_DrivingLicense_2017",
  "BF_ID",
  "BF_IDCard_2008",
  "BF_IDCard_2023",
  "BF_PC",
  "BF_ProfessionalCard_YYYY",
  "BF",
  "BG_DL",
  "BG_DrivingLicense_2002",
  "BG_DrivingLicense_2009",
  "BG_DrivingLicense_2013",
  "BG_DrivingLicense_2021",
  "BG_DrivingLicense_YYYY",
  "BG_HC",
  "BG_HealthCard_YYYY",
  "BG_ID",
  "BG_IDCard_2006",
  "BG_IDCard_2010",
  "BG_IDCard_2024",
  "BG_IDCard_YYYY",
  "BG_ResidencePermit_2008",
  "BG_ResidencePermit_2009",
  "BG_ResidencePermit_2013",
  "BG_ResidencePermit_2024",
  "BG",
  "BH_DL",
  "BH_DrivingLicense_YYYY",
  "BH_ID",
  "BH_IDCard_2007",
  "BH_IDCard_2019",
  "BH_IDCard_YYYY",
  "BH_ResidencePermit_2021",
  "BH_ResidencePermit_2022",
  "BH_ResidencePermit_YYYY",
  "BH",
  "BI_DL",
  "BI_DrivingLicense_2016",
  "BI",
  "BJ_DL",
  "BJ_DrivingLicense_2022",
  "BJ_ID",
  "BJ_IDCard_2018",
  "BJ_IDCard_YYYY",
  "BJ_ResidencePermit_YYYY",
  "BJ",
  "BM_DL",
  "BM_DrivingLicense_YYYY",
  "BM",
  "BN_DL",
  "BN_DrivingLicense_2013",
  "BN_DrivingLicense_2018",
  "BN_ID",
  "BN_IDCard_2000",
  "BN_IDCard_2022",
  "BN_ResidencePermit_2000",
  "BN_ResidencePermit_2022",
  "BN_ResidencePermit-PL_2000",
  "BN_ResidencePermit-PL_2022",
  "BN",
  "BO_DL",
  "BO_DrivingLicense_2018",
  "BO_DrivingLicense_2022",
  "BO_DrivingLicense_YYYY",
  "BO_HC",
  "BO_HealthCard_YYYY",
  "BO_ID",
  "BO_IDCard_2020",
  "BO_IDCard_2023",
  "BO_IDCard_YYYY",
  "BO",
  "BQ_DL",
  "BQ_DrivingLicense_2010",
  "BQ_ID",
  "BQ_IDCard_2010",
  "BQ",
  "BR_DL",
  "BR_DrivingLicense_2006",
  "BR_DrivingLicense_2017",
  "BR_DrivingLicense_2019",
  "BR_DrivingLicense_2022",
  "BR_DrivingLicense_YYYY",
  "BR_ID",
  "BR_IDCard_1983",
  "BR_IDCard_2014",
  "BR_IDCard_2020",
  "BR_IDCard_2022",
  "BR_IDCard_YYYY",
  "BR_IDCard-Military_YYYY",
  "BR_PC",
  "BR_ProfessionalCard_YYYY",
  "BR",
  "BS_DL",
  "BS_DrivingLicense_2012",
  "BS_DrivingLicense_YYYY",
  "BS_DrivingLicense-PL_YYYY",
  "BS_ID",
  "BS_IDCard_YYYY",
  "BS_ResidencePermit_2015",
  "BS_ResidencePermit_YYYY",
  "BS",
  "BT_DL",
  "BT_DrivingLicense_YYYY",
  "BT",
  "BW_DL",
  "BW_DrivingLicense_2006",
  "BW_ID",
  "BW_IDCard_1999",
  "BW_ResidencePermit_YYYY",
  "BW",
  "BY_DL",
  "BY_DrivingLicense_1995",
  "BY_DrivingLicense_2003",
  "BY_DrivingLicense_2010",
  "BY_DrivingLicense_YYYY",
  "BY_HC",
  "BY_HealthCard_YYYY",
  "BY_ID",
  "BY_IDCard_2021",
  "BY_ResidencePermit_2002",
  "BY_ResidencePermit_2007",
  "BY_ResidencePermit_2021",
  "BY_ResidencePermit-PL_YYYY",
  "BY",
  "BZ_DL",
  "BZ_DrivingLicense_YYYY",
  "BZ_DrivingLicense-PL_YYYY",
  "BZ_HC",
  "BZ_HealthCard_YYYY",
  "BZ_ID",
  "BZ_ResidencePermit_YYYY",
  "BZ_ResidencePermit-PL_YYYY",
  "BZ",
  "CA_DL",
  "CA_HC",
  "CA_ID",
  "CA_ResidencePermit_2002",
  "CA_ResidencePermit_2010",
  "CA_ResidencePermit_2015",
  "CA_ResidencePermit_2021",
  "CA-AB_DL",
  "CA-AB_DrivingLicense_2003",
  "CA-AB_DrivingLicense_2009",
  "CA-AB_DrivingLicense_2018",
  "CA-AB_DrivingLicense-PL_2018",
  "CA-AB_ID",
  "CA-AB_IDCard_2003",
  "CA-AB_IDCard_2009",
  "CA-AB_IDCard_2018",
  "CA-AB_IDCard-PL_2018",
  "CA-AB",
  "CA-BC_DL",
  "CA-BC_DrivingLicense_2000",
  "CA-BC_DrivingLicense_2009",
  "CA-BC_DrivingLicense_2013",
  "CA-BC_DrivingLicense_2022",
  "CA-BC_DrivingLicense-PL_2009",
  "CA-BC_DrivingLicense-PL_2013",
  "CA-BC_DrivingLicense-PL_2022",
  "CA-BC_ID",
  "CA-BC_IDCard_2000",
  "CA-BC_IDCard_2009",
  "CA-BC_IDCard_2013",
  "CA-BC_IDCard_2022",
  "CA-BC_IDCard-PL_2009",
  "CA-BC_IDCard-PL_2022",
  "CA-BC",
  "CA-MB_DL",
  "CA-MB_DrivingLicense_2007",
  "CA-MB_DrivingLicense_2014",
  "CA-MB_DrivingLicense_2020",
  "CA-MB_DrivingLicense-PL_2020",
  "CA-MB_ID",
  "CA-MB_IDCard_2009",
  "CA-MB_IDCard_2020",
  "CA-MB_IDCard-PL_2009",
  "CA-MB",
  "CA-NB_DL",
  "CA-NB_DrivingLicense_2000",
  "CA-NB_DrivingLicense_2007",
  "CA-NB_DrivingLicense_2009",
  "CA-NB_DrivingLicense_2017",
  "CA-NB_DrivingLicense-PL_2007",
  "CA-NB_ID",
  "CA-NB_IDCard_2009",
  "CA-NB_IDCard_2020",
  "CA-NB_IDCard-PL_2007",
  "CA-NB",
  "CA-NL_DL",
  "CA-NL_DrivingLicense_1999",
  "CA-NL_DrivingLicense_2007",
  "CA-NL_DrivingLicense_2017",
  "CA-NL_ID",
  "CA-NL_IDCard_2017",
  "CA-NL_IDCard-PL_2007",
  "CA-NL",
  "CA-NS_DL",
  "CA-NS_DrivingLicense_1999",
  "CA-NS_DrivingLicense_2006",
  "CA-NS_DrivingLicense_2010",
  "CA-NS_DrivingLicense_2017",
  "CA-NS_DrivingLicense-PL_2010",
  "CA-NS_ID",
  "CA-NS_IDCard_2006",
  "CA-NS_IDCard_2010",
  "CA-NS_IDCard_2017",
  "CA-NS_IDCard-PL_2010",
  "CA-NS",
  "CA-NT_DL",
  "CA-NT_DrivingLicense_2005",
  "CA-NT_DrivingLicense_2020",
  "CA-NT_ID",
  "CA-NT_IDCard_2008",
  "CA-NT_IDCard_2020",
  "CA-NT",
  "CA-NU_DL",
  "CA-NU_DrivingLicense_2009",
  "CA-NU_ID",
  "CA-NU_IDCard_2008",
  "CA-NU",
  "CA-ON_DL",
  "CA-ON_DrivingLicense_2005",
  "CA-ON_DrivingLicense_2007",
  "CA-ON_DrivingLicense_2009",
  "CA-ON_DrivingLicense_2010",
  "CA-ON_DrivingLicense_2012",
  "CA-ON_DrivingLicense-PL_2012",
  "CA-ON_HC",
  "CA-ON_HealthCard_2005",
  "CA-ON_HealthCard_2010",
  "CA-ON_HealthCard_2012",
  "CA-ON_HealthCard_2016",
  "CA-ON_ID",
  "CA-ON_IDCard_2011",
  "CA-ON",
  "CA-PE_DL",
  "CA-PE_DrivingLicense_2007",
  "CA-PE_DrivingLicense_2017",
  "CA-PE_DrivingLicense-PL_2007",
  "CA-PE_ID",
  "CA-PE_IDCard_2007",
  "CA-PE_IDCard_2017",
  "CA-PE_IDCard-PL_2002",
  "CA-PE",
  "CA-QC_DL",
  "CA-QC_DrivingLicense_2003",
  "CA-QC_DrivingLicense_2004",
  "CA-QC_DrivingLicense_2015",
  "CA-QC_DrivingLicense_YYYY",
  "CA-QC_DrivingLicense-PL_2015",
  "CA-QC_HC",
  "CA-QC_HealthCard_YYYY",
  "CA-QC_ID",
  "CA-QC_IDCard_2003",
  "CA-QC",
  "CA-SK_DL",
  "CA-SK_DrivingLicense_2000",
  "CA-SK_DrivingLicense_2011",
  "CA-SK_DrivingLicense_2016",
  "CA-SK_DrivingLicense-PL_2016",
  "CA-SK_ID",
  "CA-SK_IDCard_2000",
  "CA-SK_IDCard_2011",
  "CA-SK_IDCard_2014",
  "CA-SK_IDCard-PL_2011",
  "CA-SK_IDCard-PL_2016",
  "CA-SK",
  "CA-YT_DL",
  "CA-YT_DrivingLicense_1994",
  "CA-YT_DrivingLicense_2010",
  "CA-YT_DrivingLicense_2021",
  "CA-YT_DrivingLicense_2024",
  "CA-YT_ID",
  "CA-YT_IDCard_2010",
  "CA-YT",
  "CA",
  "CC_DL",
  "CC_DrivingLicense_2018",
  "CC_DrivingLicense-PL_2018",
  "CC",
  "CD_DL",
  "CD_DrivingLicense_1998",
  "CD_DrivingLicense_2024",
  "CD_DrivingLicense_YYYY",
  "CD_ID",
  "CD_IDCard_2023",
  "CD",
  "CF_DL",
  "CF_DrivingLicense_2007",
  "CF_DrivingLicense_2018",
  "CF_ID",
  "CF_IDCard_2021",
  "CF",
  "CG_DL",
  "CG_DrivingLicense_YYYY",
  "CG_ID",
  "CG_IDCard_2008",
  "CG_IDCard_YYYY",
  "CG_ResidencePermit_YYYY",
  "CG",
  "CH_DL",
  "CH_DrivingLicense_2003",
  "CH_DrivingLicense_2019",
  "CH_DrivingLicense_2023",
  "CH_DrivingLicense_YYYY",
  "CH_HC",
  "CH_HealthCard_YYYY",
  "CH_ID",
  "CH_IDCard_1995",
  "CH_IDCard_2003",
  "CH_IDCard_2023",
  "CH_ResidencePermit_2007",
  "CH_ResidencePermit_2008",
  "CH_ResidencePermit_2009",
  "CH_ResidencePermit_2011",
  "CH_ResidencePermit_2019",
  "CH_ResidencePermit_2020",
  "CH_ResidencePermit_YYYY",
  "CH",
  "CI_DL",
  "CI_DrivingLicense_2008",
  "CI_DrivingLicense_YYYY",
  "CI_HC",
  "CI_HealthCard_2014",
  "CI_HealthCard_2023",
  "CI_ID",
  "CI_IDCard_2009",
  "CI_IDCard_2020",
  "CI_IDCard-PL_2021",
  "CI_ResidencePermit_YYYY",
  "CI",
  "CK_DL",
  "CK_DrivingLicense_YYYY",
  "CK",
  "CL_DL",
  "CL_DrivingLicense_2003",
  "CL_ID",
  "CL_IDCard_1993",
  "CL_IDCard_2002",
  "CL_IDCard_2013",
  "CL",
  "CM_DL",
  "CM_DrivingLicense_2009",
  "CM_DrivingLicense_2017",
  "CM_ID",
  "CM_IDCard_2007",
  "CM_IDCard_2008",
  "CM_IDCard_2017",
  "CM_ResidencePermit_2017",
  "CM",
  "CN_DL",
  "CN_DrivingLicense_2008",
  "CN_DrivingLicense_2012",
  "CN_DrivingLicense_YYYY",
  "CN_DrivingLicense-PL_YYYY",
  "CN_HC",
  "CN_HealthCard_2018",
  "CN_HealthCard_YYYY",
  "CN_ID",
  "CN_IDCard_2004",
  "CN_IDCard_YYYY",
  "CN_ResidencePermit_2017",
  "CN_ResidencePermit_2023",
  "CN_ResidencePermit_YYYY",
  "CN_ResidencePermit-PL_YYYY",
  "CN",
  "CO_DL",
  "CO_DrivingLicense_2009",
  "CO_DrivingLicense_2013",
  "CO_DrivingLicense_YYYY",
  "CO_HC",
  "CO_HealthCard_YYYY",
  "CO_ID",
  "CO_IDCard_2000",
  "CO_IDCard_2020",
  "CO_IDCard-PL_YYYY",
  "CO_PC",
  "CO_ProfessionalCard_YYYY",
  "CO_ResidencePermit_2016",
  "CO_ResidencePermit_YYYY",
  "CO_ResidencePermit-PL_2021",
  "CO_ResidencePermit-PL_YYYY",
  "CO",
  "CR_DL",
  "CR_DrivingLicense_2009",
  "CR_DrivingLicense_YYYY",
  "CR_ID",
  "CR_IDCard_2007",
  "CR_IDCard_2019",
  "CR_ResidencePermit_2008",
  "CR_ResidencePermit_2023",
  "CR_ResidencePermit-PL_2008",
  "CR_ResidencePermit-PL_2023",
  "CR",
  "CU_DL",
  "CU_DrivingLicense_1979",
  "CU_DrivingLicense_2009",
  "CU_ID",
  "CU_IDCard_2014",
  "CU",
  "CV_DL",
  "CV_DrivingLicense_2014",
  "CV_DrivingLicense_YYYY",
  "CV_ID",
  "CV_IDCard_2018",
  "CV_ResidencePermit_2021",
  "CV",
  "CW_DL",
  "CW_DrivingLicense_2012",
  "CW_ID",
  "CW_IDCard_2002",
  "CW_IDCard_2021",
  "CW",
  "CX_DL",
  "CX_DrivingLicense_2018",
  "CX_DrivingLicense-PL_2018",
  "CX",
  "CY_DL",
  "CY_DrivingLicense_2015",
  "CY_DrivingLicense_2022",
  "CY_DrivingLicense_YYYY",
  "CY_HC",
  "CY_HealthCard_YYYY",
  "CY_ID",
  "CY_IDCard_2000",
  "CY_IDCard_2008",
  "CY_IDCard_2015",
  "CY_IDCard_2021",
  "CY_ResidencePermit_2014",
  "CY_ResidencePermit_2020",
  "CY_ResidencePermit_2021",
  "CY",
  "CZ_DL",
  "CZ_DrivingLicense_2001",
  "CZ_DrivingLicense_2008",
  "CZ_DrivingLicense_2013",
  "CZ_DrivingLicense_2019",
  "CZ_DrivingLicense_YYYY",
  "CZ_HC",
  "CZ_HealthCard_YYYY",
  "CZ_ID",
  "CZ_IDCard_2003",
  "CZ_IDCard_2005",
  "CZ_IDCard_2014",
  "CZ_IDCard_2021",
  "CZ_IDCard_2023",
  "CZ_IDCard_YYYY",
  "CZ_ResidencePermit_2004",
  "CZ_ResidencePermit_2006",
  "CZ_ResidencePermit_2011",
  "CZ_ResidencePermit_2020",
  "CZ_ResidencePermit_2022",
  "CZ",
  "DE_DL",
  "DE_DrivingLicense_1989",
  "DE_DrivingLicense_2004",
  "DE_DrivingLicense_2013",
  "DE_DrivingLicense_2021",
  "DE_DrivingLicense_YYYY",
  "DE_HC",
  "DE_HealthCard_YYYY",
  "DE_ID",
  "DE_IDCard_2004",
  "DE_IDCard_2007",
  "DE_IDCard_2010",
  "DE_IDCard_2016",
  "DE_IDCard_2021",
  "DE_ResidencePermit_2005",
  "DE_ResidencePermit_2011",
  "DE_ResidencePermit_2019",
  "DE_ResidencePermit_YYYY",
  "DE_ResidencePermit-PL_2005",
  "DE",
  "DJ_DL",
  "DJ_DrivingLicense_2007",
  "DJ_ID",
  "DJ_IDCard_2012",
  "DJ_IDCard_2022",
  "DJ",
  "DK_DL",
  "DK_DrivingLicense_1986",
  "DK_DrivingLicense_1997",
  "DK_DrivingLicense_2013",
  "DK_DrivingLicense_2017",
  "DK_DrivingLicense_2024",
  "DK_DrivingLicense_YYYY",
  "DK_HC",
  "DK_HealthCard_2017",
  "DK_HealthCard_YYYY",
  "DK_ID",
  "DK_ResidencePermit_1998",
  "DK_ResidencePermit_2003",
  "DK_ResidencePermit_2012",
  "DK_ResidencePermit_2020",
  "DK",
  "DM_DL",
  "DM_DrivingLicense_YYYY",
  "DM_ID",
  "DM_IDCard_2013",
  "DM",
  "DNI20",
  "DNI30",
  "DO_DL",
  "DO_DrivingLicense_2020",
  "DO_DrivingLicense_2021",
  "DO_DrivingLicense_YYYY",
  "DO_DrivingLicense-PL_YYYY",
  "DO_ID",
  "DO_IDCard_1998",
  "DO_IDCard_2014",
  "DO_ResidencePermit_YYYY",
  "DO_ResidencePermit-PL_YYYY",
  "DO",
  "DZ_DL",
  "DZ_DrivingLicense_2013",
  "DZ_DrivingLicense_2018",
  "DZ_DrivingLicense_YYYY",
  "DZ_HC",
  "DZ_HealthCard_YYYY",
  "DZ_ID",
  "DZ_IDCard_2016",
  "DZ",
  "EC_DL",
  "EC_DrivingLicense_2009",
  "EC_DrivingLicense_2013",
  "EC_DrivingLicense_2022",
  "EC_DrivingLicense_YYYY",
  "EC_ID",
  "EC_IDCard_2002",
  "EC_IDCard_2007",
  "EC_IDCard_2009",
  "EC_IDCard_2021",
  "EC",
  "EE_DL",
  "EE_DrivingLicense_1999",
  "EE_DrivingLicense_2004",
  "EE_DrivingLicense_2007",
  "EE_DrivingLicense_2013",
  "EE_DrivingLicense_2018",
  "EE_DrivingLicense_2019",
  "EE_DrivingLicense_2020",
  "EE_DrivingLicense_2021",
  "EE_DrivingLicense_YYYY",
  "EE_HC",
  "EE_HealthCard_YYYY",
  "EE_ID",
  "EE_IDCard_2002",
  "EE_IDCard_2010",
  "EE_IDCard_2011",
  "EE_IDCard_2018",
  "EE_IDCard_2021",
  "EE_ResidencePermit_2011",
  "EE_ResidencePermit_2015",
  "EE_ResidencePermit_2018",
  "EE_ResidencePermit_2020",
  "EE",
  "EG_DL",
  "EG_DrivingLicense_2024",
  "EG_DrivingLicense_YYYY",
  "EG_HC",
  "EG_HealthCard_2021",
  "EG_ID",
  "EG_IDCard_1996",
  "EG_IDCard-Military_YYYY",
  "EG_ResidencePermit_YYYY",
  "EG",
  "EH_ID",
  "EH_IDCard_YYYY",
  "EH",
  "ER_ID",
  "ER_IDCard_2014",
  "ER",
  "ES_DL",
  "ES_DrivingLicense_1997",
  "ES_DrivingLicense_2004",
  "ES_DrivingLicense_2013",
  "ES_DrivingLicense_2019",
  "ES_DrivingLicense_YYYY",
  "ES_HC",
  "ES_HealthCard_YYYY",
  "ES_ID",
  "ES_IDCard_1985",
  "ES_IDCard_1990",
  "ES_IDCard_1996",
  "ES_IDCard_2006",
  "ES_IDCard_2010",
  "ES_IDCard_2015",
  "ES_IDCard_2021",
  "ES_IDCard_YYYY",
  "ES_ResidencePermit_1997",
  "ES_ResidencePermit_2000",
  "ES_ResidencePermit_2003",
  "ES_ResidencePermit_2007",
  "ES_ResidencePermit_2010",
  "ES_ResidencePermit_2011",
  "ES_ResidencePermit_2020",
  "ES",
  "ES2_DL",
  "ES2_ID",
  "ES2",
  "ET_DL",
  "ET_DrivingLicense_YYYY",
  "ET_ID",
  "ET_IDCard_2004",
  "ET_IDCard_2019",
  "ET_IDCard_2023",
  "ET_IDCard_YYYY",
  "ET_ResidencePermit_2004",
  "ET_ResidencePermit-PL_2004",
  "ET",
  "FI_DL",
  "FI_DrivingLicense_1992",
  "FI_DrivingLicense_1996",
  "FI_DrivingLicense_1998",
  "FI_DrivingLicense_2004",
  "FI_DrivingLicense_2010",
  "FI_DrivingLicense_2013",
  "FI_DrivingLicense_2019",
  "FI_DrivingLicense_2024",
  "FI_DrivingLicense_YYYY",
  "FI_HC",
  "FI_HealthCard_YYYY",
  "FI_ID",
  "FI_IDCard_1998",
  "FI_IDCard_1999",
  "FI_IDCard_2003",
  "FI_IDCard_2005",
  "FI_IDCard_2011",
  "FI_IDCard_2012",
  "FI_IDCard_2017",
  "FI_IDCard_2021",
  "FI_IDCard_2023",
  "FI_IDCard-PL_2023",
  "FI_PC",
  "FI_ProfessionalCard_2018",
  "FI_ResidencePermit_2004",
  "FI_ResidencePermit_2006",
  "FI_ResidencePermit_2012",
  "FI_ResidencePermit_2017",
  "FI_ResidencePermit_2019",
  "FI_ResidencePermit_2020",
  "FI",
  "FJ_DL",
  "FJ_DrivingLicense_2014",
  "FJ_DrivingLicense_YYYY",
  "FJ_DrivingLicense-PL_2014",
  "FJ",
  "FK_DL",
  "FK_DrivingLicense_YYYY",
  "FK",
  "FM_DL",
  "FM_DrivingLicense_YYYY",
  "FM_ID",
  "FM_IDCard_YYYY",
  "FM",
  "FO_DL",
  "FO_DrivingLicense_2021",
  "FO_DrivingLicense_YYYY",
  "FO",
  "FR_DL",
  "FR_DrivingLicense_1985",
  "FR_DrivingLicense_1994",
  "FR_DrivingLicense_1999",
  "FR_DrivingLicense_2005",
  "FR_DrivingLicense_2006",
  "FR_DrivingLicense_2010",
  "FR_DrivingLicense_2013",
  "FR_DrivingLicense_2015",
  "FR_DrivingLicense_2017",
  "FR_DrivingLicense_2018",
  "FR_DrivingLicense_2022",
  "FR_HC",
  "FR_HealthCard_1998",
  "FR_HealthCard_2007",
  "FR_HealthCard_YYYY",
  "FR_ID",
  "FR_IDCard_1994",
  "FR_IDCard_1999",
  "FR_IDCard_2021",
  "FR_IDCard-Military_YYYY",
  "FR_PC",
  "FR_ProfessionalCard_2016",
  "FR_ResidencePermit_1996",
  "FR_ResidencePermit_2001",
  "FR_ResidencePermit_2002",
  "FR_ResidencePermit_2004",
  "FR_ResidencePermit_2011",
  "FR_ResidencePermit_2015",
  "FR_ResidencePermit_2020",
  "FR_ResidencePermit-PL_1996",
  "FR",
  "GA_HC",
  "GA_HealthCard_YYYY",
  "GA_ID",
  "GA_IDCard_2011",
  "GA_ResidencePermit_2024",
  "GA_ResidencePermit_YYYY",
  "GA",
  "GB_DL",
  "GB_DrivingLicense_1998",
  "GB_DrivingLicense_1999",
  "GB_DrivingLicense_2005",
  "GB_DrivingLicense_2007",
  "GB_DrivingLicense_2012",
  "GB_DrivingLicense_2013",
  "GB_DrivingLicense_2014",
  "GB_DrivingLicense_2015",
  "GB_DrivingLicense_2021",
  "GB_DrivingLicense_2022",
  "GB_DrivingLicense-PL_1998",
  "GB_DrivingLicense-PL_2007",
  "GB_DrivingLicense-PL_2014",
  "GB_DrivingLicense-PL_2015",
  "GB_DrivingLicense-PL_2021",
  "GB_DrivingLicense-PL_2022",
  "GB_HC",
  "GB_HealthCard_YYYY",
  "GB_ID",
  "GB_IDCard_2019",
  "GB_IDCard_YYYY",
  "GB_ResidencePermit_2003",
  "GB_ResidencePermit_2008",
  "GB_ResidencePermit_2010",
  "GB_ResidencePermit_2011",
  "GB_ResidencePermit_2015",
  "GB_ResidencePermit_2021",
  "GB",
  "GD_DL",
  "GD_DrivingLicense_YYYY",
  "GD",
  "GE_DL",
  "GE_DrivingLicense_1990",
  "GE_DrivingLicense_2006",
  "GE_DrivingLicense_2012",
  "GE_DrivingLicense_YYYY",
  "GE_ID",
  "GE_IDCard_2011",
  "GE_IDCard_YYYY",
  "GE_IDCard-PL_YYYY",
  "GE_ResidencePermit_2011",
  "GE_ResidencePermit-PL_2011",
  "GE",
  "GG_DL",
  "GG_DrivingLicense_1995",
  "GG_DrivingLicense_2007",
  "GG_DrivingLicense_2019",
  "GG_DrivingLicense-PL_2019",
  "GG",
  "GH_DL",
  "GH_DrivingLicense_2017",
  "GH_DrivingLicense_YYYY",
  "GH_HC",
  "GH_HealthCard_YYYY",
  "GH_ID",
  "GH_IDCard_2011",
  "GH_IDCard_2018",
  "GH_IDCard_YYYY",
  "GH_ResidencePermit_YYYY",
  "GH",
  "GI_DL",
  "GI_DrivingLicense_2016",
  "GI_DrivingLicense_2021",
  "GI_HC",
  "GI_HealthCard_YYYY",
  "GI_ID",
  "GI_IDCard_2000",
  "GI_IDCard_2015",
  "GI_IDCard_2021",
  "GI",
  "GL_DL",
  "GL_DrivingLicense_YYYY",
  "GL",
  "GM_DL",
  "GM_DrivingLicense_2010",
  "GM_DrivingLicense_YYYY",
  "GM_HC",
  "GM_HealthCard_2022",
  "GM_ID",
  "GM_IDCard_2018",
  "GM_IDCard_YYYY",
  "GM_ResidencePermit_YYYY",
  "GM",
  "GN_DL",
  "GN_DrivingLicense_2021",
  "GN_ID",
  "GN_IDCard_2021",
  "GN_IDCard_YYYY",
  "GN_ResidencePermit_YYYY",
  "GN",
  "GQ_DL",
  "GQ_DrivingLicense_2021",
  "GQ_DrivingLicense_YYYY",
  "GQ_ID",
  "GQ_IDCard_2021",
  "GQ_IDCard_YYYY",
  "GQ_ResidencePermit_2021",
  "GQ_ResidencePermit_YYYY",
  "GQ",
  "GR_DL",
  "GR_DrivingLicense_1987",
  "GR_DrivingLicense_2001",
  "GR_DrivingLicense_2013",
  "GR_DrivingLicense_2023",
  "GR_DrivingLicense_YYYY",
  "GR_HC",
  "GR_HealthCard_YYYY",
  "GR_ID",
  "GR_IDCard_2000",
  "GR_IDCard_2023",
  "GR_IDCard-Military_YYYY",
  "GR_IDCard-MilitaryRT_YYYY",
  "GR_ResidencePermit_2013",
  "GR_ResidencePermit_2016",
  "GR_ResidencePermit_2020",
  "GR_ResidencePermit_YYYY",
  "GR",
  "GT_DL",
  "GT_DrivingLicense_1999",
  "GT_DrivingLicense_2013",
  "GT_DrivingLicense_2018",
  "GT_DrivingLicense_2021",
  "GT_ID",
  "GT_IDCard_2009",
  "GT_IDCard_2014",
  "GT",
  "GU_DL",
  "GU_DrivingLicense_2005",
  "GU_DrivingLicense_2010",
  "GU_DrivingLicense_2016",
  "GU_DrivingLicense_2018",
  "GU_DrivingLicense_2021",
  "GU_DrivingLicense-PL_2005",
  "GU_DrivingLicense-PL_2018",
  "GU_DrivingLicense-PL_2021",
  "GU_ID",
  "GU_IDCard_2018",
  "GU_IDCard_2021",
  "GU_IDCard_YYYY",
  "GU_IDCard-PL_2018",
  "GU_IDCard-PL_2021",
  "GU",
  "GW_DL",
  "GW_DrivingLicense_2012",
  "GW_ID",
  "GW_IDCard_2006",
  "GW_IDCard_2018",
  "GW",
  "GY_DL",
  "GY_DrivingLicense_2019",
  "GY_DrivingLicense_YYYY",
  "GY_ID",
  "GY_IDCard_2009",
  "GY",
  "HK_DL",
  "HK_DrivingLicense_1990",
  "HK_DrivingLicense_2002",
  "HK_DrivingLicense_2021",
  "HK_ID",
  "HK_IDCard_2004",
  "HK_IDCard_2018",
  "HK_IDCard_YYYY",
  "HK",
  "HN_DL",
  "HN_DrivingLicense_2021",
  "HN_DrivingLicense_2022",
  "HN_DrivingLicense_2023",
  "HN_DrivingLicense_YYYY",
  "HN_ID",
  "HN_IDCard_1990",
  "HN_IDCard_2020",
  "HN_ResidencePermit_YYYY",
  "HN",
  "HR_DL",
  "HR_DrivingLicense_1993",
  "HR_DrivingLicense_2009",
  "HR_DrivingLicense_2013",
  "HR_DrivingLicense_2019",
  "HR_DrivingLicense_2021",
  "HR_DrivingLicense_2023",
  "HR_DrivingLicense_YYYY",
  "HR_HC",
  "HR_HealthCard_YYYY",
  "HR_ID",
  "HR_IDCard_1991",
  "HR_IDCard_2003",
  "HR_IDCard_2013",
  "HR_IDCard_2015",
  "HR_IDCard_2021",
  "HR_ResidencePermit_2013",
  "HR_ResidencePermit_2016",
  "HR_ResidencePermit_2020",
  "HR_ResidencePermit_2021",
  "HR",
  "HT_DL",
  "HT_DrivingLicense_YYYY",
  "HT_ID",
  "HT_IDCard_2005",
  "HT_IDCard_2018",
  "HT_IDCard_YYYY",
  "HT_ResidencePermit_2009",
  "HT_ResidencePermit_2020",
  "HT",
  "HU_DL",
  "HU_DrivingLicense_2001",
  "HU_DrivingLicense_2004",
  "HU_DrivingLicense_2009",
  "HU_DrivingLicense_2012",
  "HU_DrivingLicense_2013",
  "HU_DrivingLicense_2014",
  "HU_DrivingLicense_2019",
  "HU_DrivingLicense_2021",
  "HU_DrivingLicense_YYYY",
  "HU_HC",
  "HU_HealthCard_YYYY",
  "HU_ID",
  "HU_IDCard_2000",
  "HU_IDCard_2001",
  "HU_IDCard_2012",
  "HU_IDCard_2015",
  "HU_IDCard_2021",
  "HU_IDCard-PL_YYYY",
  "HU_ResidencePermit_2003",
  "HU_ResidencePermit_2007",
  "HU_ResidencePermit_2011",
  "HU_ResidencePermit_2013",
  "HU_ResidencePermit_2020",
  "HU_ResidencePermit_YYYY",
  "HU",
  "ID_DL",
  "ID_DrivingLicense_2019",
  "ID_DrivingLicense_2022",
  "ID_HC",
  "ID_HealthCard_2007",
  "ID_HealthCard_2014",
  "ID_HealthCard_2015",
  "ID_HealthCard_2018",
  "ID_ID",
  "ID_IDCard_2004",
  "ID_ResidencePermit_2016",
  "ID_ResidencePermit_YYYY",
  "ID_ResidencePermit-PL_YYYY",
  "ID",
  "IE_DL",
  "IE_DrivingLicense_2007",
  "IE_DrivingLicense_2013",
  "IE_DrivingLicense_2019",
  "IE_DrivingLicense-PL_2013",
  "IE_HC",
  "IE_HealthCard_YYYY",
  "IE_ID",
  "IE_Passport_2015",
  "IE_ResidencePermit_2017",
  "IE_ResidencePermit_2022",
  "IE_ResidencePermit_YYYY",
  "IE",
  "IFE2002",
  "IFE2008",
  "IFE2013",
  "IFEE",
  "IL_DL",
  "IL_DrivingLicense_2018",
  "IL_DrivingLicense_YYYY",
  "IL_ID",
  "IL_IDCard_1982",
  "IL_IDCard_1997",
  "IL_IDCard_2005",
  "IL_IDCard_2013",
  "IL_IDCard_2021",
  "IL_IDCard_YYYY",
  "IL_IDCard-Military_YYYY",
  "IL_ResidencePermit-PL_YYYY",
  "IL",
  "IM_DL",
  "IM_DrivingLicense_2006",
  "IM_DrivingLicense_2014",
  "IM",
  "IN_DL",
  "IN_DrivingLicense_2008",
  "IN_DrivingLicense_2013",
  "IN_DrivingLicense_2018",
  "IN_DrivingLicense_2019",
  "IN_DrivingLicense_2022",
  "IN_DrivingLicense_2023",
  "IN_DrivingLicense_YYYY",
  "IN_HC",
  "IN_HealthCard_YYYY",
  "IN_ID",
  "IN_IDCard_2018",
  "IN_IDCard_2020",
  "IN_IDCard_YYYY",
  "IN_ResidencePermit_YYYY",
  "IN",
  "IQ_DL",
  "IQ_DrivingLicense_2021",
  "IQ_DrivingLicense_2022",
  "IQ_DrivingLicense_YYYY",
  "IQ_HC",
  "IQ_HealthCard_YYYY",
  "IQ_ID",
  "IQ_IDCard_2015",
  "IQ_IDCard_2019",
  "IQ_IDCard_YYYY",
  "IQ_ResidencePermit_YYYY",
  "IQ",
  "IR_DL",
  "IR_DrivingLicense_2010",
  "IR_DrivingLicense_2012",
  "IR_DrivingLicense_2022",
  "IR_DrivingLicense_YYYY",
  "IR_ID",
  "IR_IDCard_1997",
  "IR_IDCard_2013",
  "IR_IDCard_2015",
  "IR_ResidencePermit_2022",
  "IR_ResidencePermit_YYYY",
  "IR_ResidencePermit-PL_YYYY",
  "IR",
  "IS_DL",
  "IS_DrivingLicense_1997",
  "IS_DrivingLicense_2001",
  "IS_DrivingLicense_2013",
  "IS_DrivingLicense_2020",
  "IS_HC",
  "IS_HealthCard_YYYY",
  "IS_ID",
  "IS_IDCard_2024",
  "IS_ResidencePermit_2007",
  "IS_ResidencePermit_2020",
  "IS_ResidencePermit_YYYY",
  "IS",
  "IT_DL",
  "IT_DrivingLicense_1959",
  "IT_DrivingLicense_1990",
  "IT_DrivingLicense_2000",
  "IT_DrivingLicense_2009",
  "IT_DrivingLicense_2013",
  "IT_DrivingLicense_2019",
  "IT_DrivingLicense_YYYY",
  "IT_HC",
  "IT_HealthCard_2004",
  "IT_HealthCard_2011",
  "IT_HealthCard_2022",
  "IT_ID",
  "IT_IDCard_2001",
  "IT_IDCard_2004",
  "IT_IDCard_2006",
  "IT_IDCard_2016",
  "IT_IDCard_2017",
  "IT_IDCard_2022",
  "IT_ResidencePermit_2007",
  "IT_ResidencePermit_2013",
  "IT_ResidencePermit_2020",
  "IT_ResidencePermit_YYYY",
  "IT",
  "JE_DL",
  "JE_DrivingLicense_2007",
  "JE_DrivingLicense_2014",
  "JE",
  "JM_DL",
  "JM_DrivingLicense_YYYY",
  "JM_ID",
  "JM_IDCard_2021",
  "JM_IDCard_YYYY",
  "JM_PC",
  "JM_ProfessionalCard_YYYY",
  "JM",
  "JO_DL",
  "JO_DrivingLicense_YYYY",
  "JO_HC",
  "JO_HealthCard_YYYY",
  "JO_ID",
  "JO_IDCard_2016",
  "JO_IDCard_YYYY",
  "JO_ResidencePermit_YYYY",
  "JO",
  "JP_DL",
  "JP_DrivingLicense_1972",
  "JP_DrivingLicense_2007",
  "JP_DrivingLicense_2019",
  "JP_DrivingLicense_YYYY",
  "JP_HC",
  "JP_HealthCard_YYYY",
  "JP_ID",
  "JP_IDCard_YYYY",
  "JP_IDCard-Military_YYYY",
  "JP_ResidencePermit_2012",
  "JP_ResidencePermit_YYYY",
  "JP",
  "KE_DL",
  "KE_DrivingLicense_2017",
  "KE_DrivingLicense_2019",
  "KE_ID",
  "KE_IDCard_1996",
  "KE_IDCard_2010",
  "KE_IDCard_2020",
  "KE_IDCard_2024",
  "KE",
  "KG_DL",
  "KG_DrivingLicense_2005",
  "KG_DrivingLicense_2012",
  "KG_DrivingLicense_2019",
  "KG_DrivingLicense_YYYY",
  "KG_ID",
  "KG_IDCard_2005",
  "KG_IDCard_2017",
  "KG_IDCard_2024",
  "KG_ResidencePermit_2023",
  "KG",
  "KH_DL",
  "KH_DrivingLicense_2012",
  "KH_DrivingLicense_2015",
  "KH_DrivingLicense_2020",
  "KH_DrivingLicense_2021",
  "KH_DrivingLicense_YYYY",
  "KH_ID",
  "KH_IDCard_1998",
  "KH_IDCard_2007",
  "KH_IDCard_2012",
  "KH",
  "KI_DL",
  "KI_DrivingLicense_YYYY",
  "KI_ID",
  "KI_IDCard_2019",
  "KI",
  "KM_ID",
  "KM_IDCard_2008",
  "KM_IDCard_2018",
  "KM_ResidencePermit_2012",
  "KM",
  "KN_DL",
  "KN_DrivingLicense_2009",
  "KN_HC",
  "KN_HealthCard_YYYY",
  "KN_ID",
  "KN_IDCard_YYYY",
  "KN",
  "KP_DL",
  "KP_DrivingLicense_YYYY",
  "KP",
  "KR_DL",
  "KR_DrivingLicense_2001",
  "KR_DrivingLicense_2008",
  "KR_DrivingLicense_YYYY",
  "KR_HC",
  "KR_HealthCard_YYYY",
  "KR_ID",
  "KR_IDCard_1999",
  "KR_IDCard_2016",
  "KR_IDCard_2020",
  "KR_IDCard_YYYY",
  "KR_ResidencePermit_2011",
  "KR_ResidencePermit_2018",
  "KR_ResidencePermit_2021",
  "KR_ResidencePermit_2023",
  "KR_ResidencePermit_YYYY",
  "KR",
  "KW_DL",
  "KW_DrivingLicense_2021",
  "KW_DrivingLicense_YYYY",
  "KW_HC",
  "KW_HealthCard_YYYY",
  "KW_ID",
  "KW_IDCard_2009",
  "KW_IDCard_2013",
  "KW_IDCard_2019",
  "KW_IDCard_YYYY",
  "KW_ResidencePermit_YYYY",
  "KW",
  "KY_DL",
  "KY_DrivingLicense_2005",
  "KY",
  "KZ_DL",
  "KZ_DrivingLicense_1996",
  "KZ_DrivingLicense_2005",
  "KZ_DrivingLicense_2015",
  "KZ_DrivingLicense_2020",
  "KZ_DrivingLicense_YYYY",
  "KZ_ID",
  "KZ_IDCard_1994",
  "KZ_IDCard_2009",
  "KZ_IDCard_2014",
  "KZ_IDCard_2024",
  "KZ_ResidencePermit_2009",
  "KZ_ResidencePermit_2014",
  "KZ",
  "LA_DL",
  "LA_DrivingLicense_YYYY",
  "LA_ID",
  "LA_IDCard_YYYY",
  "LA",
  "LB_DL",
  "LB_DrivingLicense_2002",
  "LB_DrivingLicense_2015",
  "LB_ID",
  "LB_IDCard_YYYY",
  "LB_ResidencePermit_YYYY",
  "LB_ResidencePermit-PL_YYYY",
  "LB",
  "LC_DL",
  "LC_DrivingLicense_YYYY",
  "LC_ID",
  "LC_IDCard_YYYY",
  "LC",
  "LI_DL",
  "LI_DrivingLicense_2003",
  "LI_DrivingLicense_2019",
  "LI_HC",
  "LI_HealthCard_YYYY",
  "LI_ID",
  "LI_IDCard_1995",
  "LI_IDCard_2009",
  "LI_IDCard_2024",
  "LI_ResidencePermit_2009",
  "LI_ResidencePermit_2011",
  "LI_ResidencePermit_2020",
  "LI_ResidencePermit_2024",
  "LI",
  "LK_DL",
  "LK_DrivingLicense_2009",
  "LK_DrivingLicense_2023",
  "LK_ID",
  "LK_IDCard_1972",
  "LK_IDCard_2017",
  "LK",
  "LR_DL",
  "LR_DrivingLicense_2018",
  "LR_DrivingLicense_YYYY",
  "LR_ID",
  "LR_IDCard_2019",
  "LR",
  "LS_DL",
  "LS_DrivingLicense_YYYY",
  "LS_ID",
  "LS_IDCard_2013",
  "LS",
  "LT_DL",
  "LT_DrivingLicense_1992",
  "LT_DrivingLicense_2003",
  "LT_DrivingLicense_2007",
  "LT_DrivingLicense_2013",
  "LT_DrivingLicense_2016",
  "LT_DrivingLicense_2019",
  "LT_DrivingLicense_2020",
  "LT_DrivingLicense_YYYY",
  "LT_HC",
  "LT_HealthCard_YYYY",
  "LT_ID",
  "LT_IDCard_2002",
  "LT_IDCard_2009",
  "LT_IDCard_2012",
  "LT_IDCard_2021",
  "LT_PC",
  "LT_ProfessionalCard_2023",
  "LT_ResidencePermit_2004",
  "LT_ResidencePermit_2012",
  "LT_ResidencePermit_2019",
  "LT_ResidencePermit_2020",
  "LT_ResidencePermit_2022",
  "LT",
  "LU_DL",
  "LU_DrivingLicense_2011",
  "LU_DrivingLicense_2013",
  "LU_HC",
  "LU_HealthCard_YYYY",
  "LU_ID",
  "LU_IDCard_2004",
  "LU_IDCard_2013",
  "LU_IDCard_2014",
  "LU_IDCard_2021",
  "LU_ResidencePermit_2004",
  "LU_ResidencePermit_2011",
  "LU_ResidencePermit_2020",
  "LU_ResidencePermit_2021",
  "LU",
  "LV_DL",
  "LV_DrivingLicense_1993",
  "LV_DrivingLicense_2004",
  "LV_DrivingLicense_2013",
  "LV_DrivingLicense_2019",
  "LV_DrivingLicense_2023",
  "LV_DrivingLicense_YYYY",
  "LV_DrivingLicense-PL_2004",
  "LV_DrivingLicense-PL_2013",
  "LV_DrivingLicense-PL_2023",
  "LV_HC",
  "LV_HealthCard_YYYY",
  "LV_ID",
  "LV_IDCard_2012",
  "LV_IDCard_2019",
  "LV_IDCard_2021",
  "LV_ResidencePermit_2004",
  "LV_ResidencePermit_2012",
  "LV_ResidencePermit_2021",
  "LV",
  "LY_DL",
  "LY_DrivingLicense_YYYY",
  "LY_ID",
  "LY_IDCard_YYYY",
  "LY",
  "MA_DL",
  "MA_DrivingLicense_2008",
  "MA_DrivingLicense_2020",
  "MA_ID",
  "MA_IDCard_1996",
  "MA_IDCard_2008",
  "MA_IDCard_2020",
  "MA_PC",
  "MA_ProfessionalCard_YYYY",
  "MA",
  "MC_DL",
  "MC_DrivingLicense_2015",
  "MC_ID",
  "MC_IDCard_2009",
  "MC_IDCard_2021",
  "MC_ResidencePermit_1998",
  "MC_ResidencePermit_2021",
  "MC_ResidencePermit-PL_1998",
  "MC",
  "MD_DL",
  "MD_DrivingLicense_1995",
  "MD_DrivingLicense_2008",
  "MD_DrivingLicense_2015",
  "MD_DrivingLicense_2018",
  "MD_DrivingLicense_YYYY",
  "MD_ID",
  "MD_IDCard_1997",
  "MD_IDCard_1999",
  "MD_IDCard_2000",
  "MD_IDCard_2004",
  "MD_IDCard_2013",
  "MD_IDCard_2014",
  "MD_IDCard_2015",
  "MD_ResidencePermit_1996",
  "MD_ResidencePermit_2005",
  "MD_ResidencePermit_2013",
  "MD_ResidencePermit_2016",
  "MD",
  "ME_DL",
  "ME_DrivingLicense_2008",
  "ME_DrivingLicense_2020",
  "ME_DrivingLicense_YYYY",
  "ME_ID",
  "ME_IDCard_2008",
  "ME_IDCard_2020",
  "ME_ResidencePermit_2008",
  "ME_ResidencePermit_2020",
  "ME_ResidencePermit-PL_2008",
  "ME_ResidencePermit-PL_2020",
  "ME",
  "MF_DL",
  "MF_DrivingLicense_YYYY",
  "MF_ID",
  "MF_IDCard_YYYY",
  "MF",
  "MG_DL",
  "MG_DrivingLicense_2015",
  "MG_DrivingLicense_2019",
  "MG_ID",
  "MG_IDCard_YYYY",
  "MG_ResidencePermit_YYYY",
  "MG",
  "MH_DL",
  "MH_DrivingLicense_YYYY",
  "MH_ID",
  "MH_IDCard_YYYY",
  "MH",
  "MK_DL",
  "MK_DrivingLicense_2007",
  "MK_DrivingLicense_2021",
  "MK_DrivingLicense_YYYY",
  "MK_HC",
  "MK_HealthCard_YYYY",
  "MK_ID",
  "MK_IDCard_2007",
  "MK_IDCard_2021",
  "MK_IDCard_YYYY",
  "MK_ResidencePermit_2008",
  "MK_ResidencePermit-PL_2008",
  "MK_ResidencePermit-PL_2021",
  "MK",
  "ML_DL",
  "ML_DrivingLicense_YYYY",
  "ML_HC",
  "ML_HealthCard_YYYY",
  "ML_ID",
  "ML_IDCard_2000",
  "ML_IDCard_2013",
  "ML_IDCard_2022",
  "ML",
  "MM_DL",
  "MM_DrivingLicense_2019",
  "MM_DrivingLicense_YYYY",
  "MM_HC",
  "MM_HealthCard_YYYY",
  "MM_PC",
  "MM_ProfessionalCard_YYYY",
  "MM",
  "MN_DL",
  "MN_DrivingLicense_2012",
  "MN_DrivingLicense_YYYY",
  "MN_ID",
  "MN_IDCard_1999",
  "MN_IDCard_2012",
  "MN_IDCard_2022",
  "MN_ResidencePermit_2023",
  "MN",
  "MO_DL",
  "MO_DrivingLicense_2007",
  "MO_DrivingLicense_2019",
  "MO_ID",
  "MO_ResidencePermit_2002",
  "MO_ResidencePermit_2013",
  "MO_ResidencePermit_2023",
  "MO",
  "MP_DL",
  "MP_DrivingLicense_2010",
  "MP_DrivingLicense_2016",
  "MP_DrivingLicense_2019",
  "MP_DrivingLicense_YYYY",
  "MP_DrivingLicense-PL_2019",
  "MP_ID",
  "MP_IDCard_YYYY",
  "MP",
  "MR_DL",
  "MR_DrivingLicense_YYYY",
  "MR_ID",
  "MR_IDCard_2012",
  "MR_IDCard_2021",
  "MR_ResidencePermit_2012",
  "MR",
  "MT_DL",
  "MT_DrivingLicense_2001",
  "MT_DrivingLicense_2003",
  "MT_DrivingLicense_2013",
  "MT_DrivingLicense_2017",
  "MT_DrivingLicense_2020",
  "MT_HC",
  "MT_HealthCard_YYYY",
  "MT_ID",
  "MT_IDCard_2002",
  "MT_IDCard_2014",
  "MT_IDCard_2020",
  "MT_IDCard_2022",
  "MT_ResidencePermit_2013",
  "MT_ResidencePermit_2020",
  "MT_ResidencePermit_2021",
  "MT_ResidencePermit_2022",
  "MT",
  "MU_DL",
  "MU_DrivingLicense_YYYY",
  "MU_ID",
  "MU_IDCard_2013",
  "MU_IDCard_2024",
  "MU",
  "MV_DL",
  "MV_DrivingLicense_YYYY",
  "MV_ID",
  "MV_IDCard_YYYY",
  "MV",
  "MW_DL",
  "MW_DrivingLicense_2005",
  "MW_DrivingLicense_YYYY",
  "MW_ID",
  "MW_IDCard_2016",
  "MW_ResidencePermit_YYYY",
  "MW",
  "MX_DL",
  "MX_DrivingLicense_2007",
  "MX_DrivingLicense_2010",
  "MX_DrivingLicense_2011",
  "MX_DrivingLicense_2012",
  "MX_DrivingLicense_2013",
  "MX_DrivingLicense_2014",
  "MX_DrivingLicense_2015",
  "MX_DrivingLicense_2016",
  "MX_DrivingLicense_2017",
  "MX_DrivingLicense_2018",
  "MX_DrivingLicense_2019",
  "MX_DrivingLicense_2020",
  "MX_DrivingLicense_2021",
  "MX_DrivingLicense_2022",
  "MX_DrivingLicense_2023",
  "MX_DrivingLicense_2024",
  "MX_DrivingLicense_YYYY",
  "MX_HC",
  "MX_HealthCard_YYYY",
  "MX_ID",
  "MX_IDCard_2008",
  "MX_IDCard_2013",
  "MX_IDCard_2014",
  "MX_IDCard_2019",
  "MX_ProfessionalCard_2008",
  "MX_ResidencePermit_2010",
  "MX_ResidencePermit_2022",
  "MX_ResidencePermit_YYYY",
  "MX_ResidencePermit-PL_2022",
  "MX",
  "MX2_ID",
  "MX2_PC",
  "MX2",
  "MY_DL",
  "MY_DrivingLicense_1989",
  "MY_DrivingLicense_2013",
  "MY_DrivingLicense_2024",
  "MY_DrivingLicense_YYYY",
  "MY_DrivingLicense-PL_1989",
  "MY_ID",
  "MY_IDCard_2000",
  "MY_IDCard_2001",
  "MY_IDCard_2012",
  "MY_IDCard_YYYY",
  "MY_ResidencePermit_2006",
  "MY_ResidencePermit-PL_2009",
  "MY",
  "MYS2001",
  "MZ_DL",
  "MZ_DrivingLicense_2022",
  "MZ_DrivingLicense_YYYY",
  "MZ_ID",
  "MZ_IDCard_2008",
  "MZ_IDCard_2010",
  "MZ_IDCard_2019",
  "MZ_IDCard_2022",
  "MZ_ResidencePermit_2010",
  "MZ_ResidencePermit_2019",
  "MZ",
  "NA_DL",
  "NA_DrivingLicense_2008",
  "NA_DrivingLicense_2022",
  "NA_ID",
  "NA_IDCard_2001",
  "NA",
  "NC_DL",
  "NC_DrivingLicense_YYYY",
  "NC",
  "NE_DL",
  "NE_DrivingLicense_2019",
  "NE",
  "NG_DL",
  "NG_DrivingLicense_2009",
  "NG_DrivingLicense_2011",
  "NG_DrivingLicense-PL_2011",
  "NG_ID",
  "NG_IDCard_2003",
  "NG_IDCard_2014",
  "NG_IDCard_2021",
  "NG_IDCard_YYYY",
  "NG_ResidencePermit_YYYY",
  "NG",
  "NI_DL",
  "NI_DrivingLicense_2003",
  "NI_DrivingLicense_2009",
  "NI_ID",
  "NI_IDCard_1993",
  "NI_IDCard_2017",
  "NI_IDCard_YYYY",
  "NI_ResidencePermit_YYYY",
  "NI",
  "NIE2003",
  "NIE2010",
  "NIE2011",
  "NL_DL",
  "NL_DrivingLicense_1987",
  "NL_DrivingLicense_1996",
  "NL_DrivingLicense_2002",
  "NL_DrivingLicense_2006",
  "NL_DrivingLicense_2013",
  "NL_DrivingLicense_2014",
  "NL_DrivingLicense_2019",
  "NL_DrivingLicense_2021",
  "NL_DrivingLicense_YYYY",
  "NL_HC",
  "NL_HealthCard_YYYY",
  "NL_ID",
  "NL_IDCard_1997",
  "NL_IDCard_2001",
  "NL_IDCard_2002",
  "NL_IDCard_2006",
  "NL_IDCard_2008",
  "NL_IDCard_2011",
  "NL_IDCard_2014",
  "NL_IDCard_2021",
  "NL_IDCard-Military_YYYY",
  "NL_ResidencePermit_2001",
  "NL_ResidencePermit_2011",
  "NL_ResidencePermit_2012",
  "NL_ResidencePermit_2020",
  "NL",
  "NO_DL",
  "NO_DrivingLicense_1989",
  "NO_DrivingLicense_1998",
  "NO_DrivingLicense_2004",
  "NO_DrivingLicense_2007",
  "NO_DrivingLicense_2013",
  "NO_DrivingLicense_2018",
  "NO_DrivingLicense_2019",
  "NO_DrivingLicense_2022",
  "NO_DrivingLicense_2023",
  "NO_DrivingLicense_YYYY",
  "NO_HC",
  "NO_HealthCard_YYYY",
  "NO_ID",
  "NO_IDCard_2020",
  "NO_IDCard_2021",
  "NO_ResidencePermit_2004",
  "NO_ResidencePermit_2012",
  "NO_ResidencePermit_2018",
  "NO_ResidencePermit_2020",
  "NO",
  "NP_DL",
  "NP_DrivingLicense_2015",
  "NP_DrivingLicense_2021",
  "NP_DrivingLicense_YYYY",
  "NP_DrivingLicense-PL_2021",
  "NP_ID",
  "NP_IDCard_2017",
  "NP_IDCard_2021",
  "NP_IDCard_YYYY",
  "NP",
  "NR_DL",
  "NR_DrivingLicense_YYYY",
  "NR",
  "NU_DL",
  "NU_DrivingLicense_2022",
  "NU_DrivingLicense_YYYY",
  "NU",
  "NZ_DL",
  "NZ_DrivingLicense_2000",
  "NZ_DrivingLicense_2007",
  "NZ_DrivingLicense_2013",
  "NZ_DrivingLicense_2014",
  "NZ_DrivingLicense-PL_2007",
  "NZ_DrivingLicense-PL_2013",
  "NZ_DrivingLicense-PL_2014",
  "NZ",
  "OM_DL",
  "OM_DrivingLicense_2000",
  "OM_DrivingLicense_2015",
  "OM_DrivingLicense_2018",
  "OM_ID",
  "OM_IDCard_2006",
  "OM_IDCard_2016",
  "OM_IDCard_YYYY",
  "OM_ResidencePermit_2016",
  "OM_ResidencePermit_YYYY",
  "OM",
  "PA_DL",
  "PA_DrivingLicense_2007",
  "PA_DrivingLicense_2012",
  "PA_ID",
  "PA_IDCard_2003",
  "PA_IDCard_2010",
  "PA_IDCard_2017",
  "PA_ResidencePermit_2010",
  "PA_ResidencePermit_2017",
  "PA_ResidencePermit_2022",
  "PA",
  "Passport",
  "PE_DL",
  "PE_DrivingLicense_YYYY",
  "PE_ID",
  "PE_IDCard_1997",
  "PE_IDCard_2007",
  "PE_IDCard_2013",
  "PE_IDCard_2020",
  "PE_ResidencePermit_2017",
  "PE_ResidencePermit_2021",
  "PE_ResidencePermit_YYYY",
  "PE_ResidencePermit-PL_2017",
  "PE_ResidencePermit-PL_2021",
  "PE",
  "PF_DL",
  "PF_DrivingLicense_2016",
  "PF",
  "PG_DL",
  "PG_DrivingLicense_YYYY",
  "PG_ID",
  "PG_IDCard_2015",
  "PG",
  "PH_DL",
  "PH_DrivingLicense_2000",
  "PH_DrivingLicense_2017",
  "PH_DrivingLicense_2020",
  "PH_DrivingLicense_2022",
  "PH_DrivingLicense_2023",
  "PH_HC",
  "PH_HealthCard_2010",
  "PH_HealthCard_2012",
  "PH_HealthCard_2015",
  "PH_HealthCard_YYYY",
  "PH_ID",
  "PH_IDCard_2011",
  "PH_IDCard_2015",
  "PH_IDCard_2016",
  "PH_IDCard_2018",
  "PH_IDCard_2020",
  "PH_IDCard_2022",
  "PH_IDCard_2024",
  "PH_IDCard_YYYY",
  "PH_IDCard-PO_2016",
  "PH_PC",
  "PH_ProfessionalCard_2019",
  "PH_ResidencePermit_YYYY",
  "PH",
  "PK_DL",
  "PK_DrivingLicense_2009",
  "PK_DrivingLicense_2010",
  "PK_DrivingLicense_2014",
  "PK_DrivingLicense_2015",
  "PK_DrivingLicense_2017",
  "PK_DrivingLicense_2021",
  "PK_DrivingLicense_2023",
  "PK_DrivingLicense_YYYY",
  "PK_ID",
  "PK_IDCard_2002",
  "PK_IDCard_2012",
  "PK_ResidencePermit_2012",
  "PK",
  "PL_DL",
  "PL_DrivingLicense_1993",
  "PL_DrivingLicense_1999",
  "PL_DrivingLicense_2004",
  "PL_DrivingLicense_2013",
  "PL_DrivingLicense_2019",
  "PL_DrivingLicense_2022",
  "PL_DrivingLicense_YYYY",
  "PL_HC",
  "PL_HealthCard_YYYY",
  "PL_ID",
  "PL_IDCard_2001",
  "PL_IDCard_2003",
  "PL_IDCard_2012",
  "PL_IDCard_2015",
  "PL_IDCard_2019",
  "PL_IDCard_2021",
  "PL_ResidencePermit_2001",
  "PL_ResidencePermit_2003",
  "PL_ResidencePermit_2004",
  "PL_ResidencePermit_2011",
  "PL_ResidencePermit_2014",
  "PL_ResidencePermit_2020",
  "PL_ResidencePermit_2021",
  "PL_ResidencePermit-PL_1998",
  "PL",
  "PR_DL",
  "PR_DrivingLicense_1998",
  "PR_DrivingLicense_2005",
  "PR_DrivingLicense_2009",
  "PR_DrivingLicense_2016",
  "PR_DrivingLicense-PL_1998",
  "PR_DrivingLicense-PL_2005",
  "PR_ID",
  "PR_IDCard_2009",
  "PR_IDCard_2016",
  "PR_IDCard-PL_2005",
  "PR",
  "PS_DL",
  "PS_DrivingLicense_2010",
  "PS_DrivingLicense_2011",
  "PS_DrivingLicense_2019",
  "PS_HC",
  "PS_HealthCard_YYYY",
  "PS_ID",
  "PS_IDCard_2003",
  "PS_IDCard_YYYY",
  "PS",
  "PT_DL",
  "PT_DrivingLicense_1990",
  "PT_DrivingLicense_1999",
  "PT_DrivingLicense_2013",
  "PT_DrivingLicense_2021",
  "PT_DrivingLicense_YYYY",
  "PT_HC",
  "PT_HealthCard_YYYY",
  "PT_ID",
  "PT_IDCard_1987",
  "PT_IDCard_2015",
  "PT_IDCard_2020",
  "PT_IDCard_2024",
  "PT_ResidencePermit_2005",
  "PT_ResidencePermit_2008",
  "PT_ResidencePermit_2013",
  "PT_ResidencePermit_2017",
  "PT_ResidencePermit_2019",
  "PT_ResidencePermit_2020",
  "PT_ResidencePermit-PL_2015",
  "PT",
  "PW_DL",
  "PW_DrivingLicense_YYYY",
  "PW_ID",
  "PW_IDCard_2022",
  "PW",
  "PY_DL",
  "PY_DrivingLicense_2016",
  "PY_DrivingLicense_YYYY",
  "PY_ID",
  "PY_IDCard_2007",
  "PY_IDCard_2009",
  "PY_IDCard_2012",
  "PY_IDCard_2023",
  "PY_ResidencePermit_YYYY",
  "PY_ResidencePermit-PL_2023",
  "PY_ResidencePermit-PL_YYYY",
  "PY",
  "QA_DL",
  "QA_DrivingLicense_YYYY",
  "QA_HC",
  "QA_HealthCard_YYYY",
  "QA_ID",
  "QA_IDCard_2004",
  "QA_IDCard_2007",
  "QA_IDCard_2011",
  "QA_IDCard_2015",
  "QA_IDCard-Military_YYYY",
  "QA_ResidencePermit_2015",
  "QA",
  "RO_DL",
  "RO_DrivingLicense_1996",
  "RO_DrivingLicense_2013",
  "RO_DrivingLicense_YYYY",
  "RO_HC",
  "RO_HealthCard_YYYY",
  "RO_ID",
  "RO_IDCard_1997",
  "RO_IDCard_2009",
  "RO_IDCard_2021",
  "RO_ResidencePermit_2007",
  "RO_ResidencePermit_2009",
  "RO_ResidencePermit_2021",
  "RO",
  "RS_DL",
  "RS_DrivingLicense_2011",
  "RS_DrivingLicense_2018",
  "RS_DrivingLicense_YYYY",
  "RS_DrivingLicense-PL_YYYY",
  "RS_HC",
  "RS_HealthCard_YYYY",
  "RS_ID",
  "RS_IDCard_2008",
  "RS_IDCard_2009",
  "RS_ResidencePermit-PL_2024",
  "RS_ResidencePermit-PL_YYYY",
  "RS",
  "RU_DL",
  "RU_DrivingLicense_1963",
  "RU_DrivingLicense_1993",
  "RU_DrivingLicense_1996",
  "RU_DrivingLicense_1999",
  "RU_DrivingLicense_2011",
  "RU_DrivingLicense_2019",
  "RU_DrivingLicense_YYYY",
  "RU_HC",
  "RU_HealthCard_2011",
  "RU_HealthCard_2012",
  "RU_HealthCard_YYYY",
  "RU_ID",
  "RU_IDCard_2007",
  "RU_ResidencePermit_2005",
  "RU_ResidencePermit-PL_2001",
  "RU_ResidencePermit-PL_YYYY",
  "RU",
  "RW_DL",
  "RW_DrivingLicense_2008",
  "RW_ID",
  "RW_IDCard_2008",
  "RW",
  "SA_DL",
  "SA_DrivingLicense_2021",
  "SA_DrivingLicense_2023",
  "SA_HC",
  "SA_HealthCard_YYYY",
  "SA_ID",
  "SA_IDCard_2010",
  "SA_IDCard_2018",
  "SA_IDCard_2021",
  "SA_ResidencePermit_2015",
  "SA_ResidencePermit_2022",
  "SA_ResidencePermit_2024",
  "SA_ResidencePermit_YYYY",
  "SA",
  "SB_DL",
  "SB_DrivingLicense_2014",
  "SB",
  "SC_DL",
  "SC_DrivingLicense_YYYY",
  "SC_ID",
  "SC_IDCard_YYYY",
  "SC",
  "SD_DL",
  "SD_DrivingLicense_2005",
  "SD_DrivingLicense_2021",
  "SD_HC",
  "SD_HealthCard_2020",
  "SD_ID",
  "SD_IDCard_2011",
  "SD_IDCard_YYYY",
  "SD_IDCard-Military_2020",
  "SD_ResidencePermit_YYYY",
  "SD",
  "SE_DL",
  "SE_DrivingLicense_1997",
  "SE_DrivingLicense_1999",
  "SE_DrivingLicense_2007",
  "SE_DrivingLicense_2009",
  "SE_DrivingLicense_2012",
  "SE_DrivingLicense_2013",
  "SE_DrivingLicense_2016",
  "SE_DrivingLicense_YYYY",
  "SE_HC",
  "SE_HealthCard_YYYY",
  "SE_ID",
  "SE_IDCard_2003",
  "SE_IDCard_2005",
  "SE_IDCard_2007",
  "SE_IDCard_2012",
  "SE_IDCard_2021",
  "SE_IDCard_2022",
  "SE_ResidencePermit_2002",
  "SE_ResidencePermit_2006",
  "SE_ResidencePermit_2011",
  "SE_ResidencePermit_2012",
  "SE_ResidencePermit_2020",
  "SE_ResidencePermit_2022",
  "SE_ResidencePermit_YYYY",
  "SE",
  "SG_DL",
  "SG_DrivingLicense_2002",
  "SG_DrivingLicense_YYYY",
  "SG_ID",
  "SG_IDCard_2011",
  "SG_IDCard_2013",
  "SG_IDCard_YYYY",
  "SG",
  "SI_DL",
  "SI_DrivingLicense_2009",
  "SI_DrivingLicense_2013",
  "SI_DrivingLicense_2019",
  "SI_DrivingLicense_YYYY",
  "SI_HC",
  "SI_HealthCard_YYYY",
  "SI_ID",
  "SI_IDCard_1998",
  "SI_IDCard_2022",
  "SI_ResidencePermit_2004",
  "SI_ResidencePermit_2007",
  "SI_ResidencePermit_2011",
  "SI_ResidencePermit_2018",
  "SI_ResidencePermit_2022",
  "SI",
  "SK_DL",
  "SK_DrivingLicense_2008",
  "SK_DrivingLicense_2009",
  "SK_DrivingLicense_2013",
  "SK_DrivingLicense_2015",
  "SK_DrivingLicense_2019",
  "SK_DrivingLicense_YYYY",
  "SK_HC",
  "SK_HealthCard_YYYY",
  "SK_ID",
  "SK_IDCard_1993",
  "SK_IDCard_2008",
  "SK_IDCard_2013",
  "SK_IDCard_2015",
  "SK_IDCard_2021",
  "SK_IDCard_2022",
  "SK_ResidencePermit_2004",
  "SK_ResidencePermit_2011",
  "SK_ResidencePermit_2020",
  "SK",
  "SL_DL",
  "SL_DrivingLicense_2021",
  "SL_DrivingLicense_YYYY",
  "SL_HC",
  "SL_HealthCard_YYYY",
  "SL_ID",
  "SL_IDCard_2000",
  "SL_IDCard_2009",
  "SL_IDCard_2022",
  "SL",
  "SM_DL",
  "SM_DrivingLicense_2003",
  "SM_DrivingLicense_2019",
  "SM_DrivingLicense_2021",
  "SM_ID",
  "SM_IDCard_2004",
  "SM_IDCard_2017",
  "SM",
  "SN_DL",
  "SN_DrivingLicense_2018",
  "SN_ID",
  "SN_IDCard_2005",
  "SN_IDCard_2016",
  "SN",
  "SO_DL",
  "SO_DrivingLicense_2013",
  "SO_DrivingLicense_2014",
  "SO_DrivingLicense_YYYY",
  "SO_ID",
  "SO_IDCard_2007",
  "SO_IDCard_2014",
  "SO_IDCard_YYYY",
  "SO_PC",
  "SO_ProfessionalCard_YYYY",
  "SO",
  "SR_DL",
  "SR_DrivingLicense_2013",
  "SR_DrivingLicense_2021",
  "SR_ID",
  "SR_IDCard_2014",
  "SR_IDCard_2019",
  "SR_IDCard_YYYY",
  "SR",
  "SS_DL",
  "SS_DrivingLicense_YYYY",
  "SS_ID",
  "SS_IDCard_2011",
  "SS_ResidencePermit_YYYY",
  "SS",
  "ST_DL",
  "ST_DrivingLicense_YYYY",
  "ST",
  "SV_DL",
  "SV_DrivingLicense_2010",
  "SV_DrivingLicense_2013",
  "SV_DrivingLicense_2021",
  "SV_ID",
  "SV_IDCard_2001",
  "SV_IDCard_2006",
  "SV_IDCard_2010",
  "SV_IDCard_2011",
  "SV_IDCard_2016",
  "SV_IDCard_2022",
  "SV_ResidencePermit_2021",
  "SV_ResidencePermit_YYYY",
  "SV_ResidencePermit-PL_2021",
  "SV",
  "SX_DL",
  "SX_DrivingLicense_2017",
  "SX_DrivingLicense_YYYY",
  "SX_ID",
  "SX_IDCard_2017",
  "SX_IDCard_YYYY",
  "SX",
  "SY_DL",
  "SY_DrivingLicense_2008",
  "SY_DrivingLicense_YYYY",
  "SY_ID",
  "SY_IDCard_2000",
  "SY_ResidencePermit-PL_2002",
  "SY_ResidencePermit-PL_YYYY",
  "SY",
  "SZ_DL",
  "SZ_DrivingLicense_YYYY",
  "SZ_ID",
  "SZ_IDCard_YYYY",
  "SZ",
  "TC_DL",
  "TC_DrivingLicense_YYYY",
  "TC_ID",
  "TC_IDCard_2012",
  "TC",
  "TD_DL",
  "TD_DrivingLicense_YYYY",
  "TD_ID",
  "TD_IDCard_2002",
  "TD_IDCard_2019",
  "TD",
  "TG_DL",
  "TG_DrivingLicense_2003",
  "TG_DrivingLicense_YYYY",
  "TG_HC",
  "TG_HealthCard_2022",
  "TG_ID",
  "TG_IDCard_YYYY",
  "TG_ResidencePermit_YYYY",
  "TG",
  "TH_DL",
  "TH_DrivingLicense_2010",
  "TH_DrivingLicense_2017",
  "TH_DrivingLicense_YYYY",
  "TH_ID",
  "TH_IDCard_2004",
  "TH_IDCard_2005",
  "TH_IDCard_2008",
  "TH_IDCard_2011",
  "TH",
  "TJ_DL",
  "TJ_DrivingLicense_2014",
  "TJ_DrivingLicense_YYYY",
  "TJ_ID",
  "TJ_IDCard_2014",
  "TJ",
  "TL_DL",
  "TL_DrivingLicense_YYYY",
  "TL_ID",
  "TL_IDCard_2004",
  "TL_ResidencePermit_YYYY",
  "TL",
  "TM_DL",
  "TM_DrivingLicense_1999",
  "TM_ID",
  "TM_ResidencePermit_2013",
  "TM",
  "TN_DL",
  "TN_DrivingLicense_2002",
  "TN_DrivingLicense_2023",
  "TN_ID",
  "TN_IDCard_2008",
  "TN_ResidencePermit_YYYY",
  "TN",
  "TO_DL",
  "TO_DrivingLicense_2010",
  "TO_ID",
  "TO_IDCard_2010",
  "TO",
  "TR_DL",
  "TR_DrivingLicense_2016",
  "TR_DrivingLicense_YYYY",
  "TR_ID",
  "TR_IDCard_2001",
  "TR_IDCard_2016",
  "TR_IDCard_YYYY",
  "TR_PC",
  "TR_ProfessionalCard_YYYY",
  "TR_ResidencePermit_2014",
  "TR_ResidencePermit_2020",
  "TR_ResidencePermit_2023",
  "TR_ResidencePermit_YYYY",
  "TR",
  "TT_DL",
  "TT_DrivingLicense_2010",
  "TT_DrivingLicense_2017",
  "TT_DrivingLicense_2022",
  "TT_ID",
  "TT_IDCard_2012",
  "TT_IDCard_2020",
  "TT",
  "TW_DL",
  "TW_DrivingLicense_2007",
  "TW_DrivingLicense_2011",
  "TW_HC",
  "TW_HealthCard_YYYY",
  "TW_ID",
  "TW_IDCard_2020",
  "TW_IDCard_YYYY",
  "TW",
  "TZ_DL",
  "TZ_DrivingLicense_2010",
  "TZ_DrivingLicense_2018",
  "TZ_DrivingLicense_YYYY",
  "TZ_HC",
  "TZ_HealthCard_YYYY",
  "TZ_ID",
  "TZ_IDCard_2013",
  "TZ_IDCard_2016",
  "TZ_IDCard_2019",
  "TZ_IDCard_2023",
  "TZ_IDCard_YYYY",
  "TZ_ResidencePermit_2020",
  "TZ",
  "UA_DL",
  "UA_DrivingLicense_1995",
  "UA_DrivingLicense_1996",
  "UA_DrivingLicense_2002",
  "UA_DrivingLicense_2004",
  "UA_DrivingLicense_2005",
  "UA_DrivingLicense_2013",
  "UA_DrivingLicense_2014",
  "UA_DrivingLicense_2020",
  "UA_DrivingLicense_2021",
  "UA_DrivingLicense_YYYY",
  "UA_HC",
  "UA_HealthCard_YYYY",
  "UA_ID",
  "UA_IDCard_2016",
  "UA_IDCard_YYYY",
  "UA_ResidencePermit_2018",
  "UA_ResidencePermit_YYYY",
  "UA_ResidencePermit-PL_2018",
  "UA_ResidencePermit-PL_YYYY",
  "UA",
  "UG_DL",
  "UG_DrivingLicense_2005",
  "UG_DrivingLicense_2018",
  "UG_DrivingLicense_2021",
  "UG_ID",
  "UG_IDCard_2014",
  "UG_IDCard_YYYY",
  "UG",
  "US_DL",
  "US_DrivingLicense_1997",
  "US_DrivingLicense_2003",
  "US_DrivingLicense_YYYY",
  "US_DrivingLicense-PL_YYYY",
  "US_HC",
  "US_HealthCard_1973",
  "US_HealthCard_1994",
  "US_HealthCard_2007",
  "US_HealthCard_YYYY",
  "US_ID",
  "US_IDCard_2008",
  "US_IDCard_2015",
  "US_IDCard_2017",
  "US_IDCard_2018",
  "US_IDCard_YYYY",
  "US_IDCard-MilitaryRR_1993",
  "US_IDCard-MilitaryRS_1993",
  "US_IDCard-MilitaryRT_1993",
  "US_IDCard-MilitaryRT_1994",
  "US_ResidencePermit_1997",
  "US_ResidencePermit_2010",
  "US_ResidencePermit_2017",
  "US_ResidencePermit_2023",
  "US-AK_DL",
  "US-AK_DrivingLicense_2005",
  "US-AK_DrivingLicense_2014",
  "US-AK_DrivingLicense_2018",
  "US-AK_DrivingLicense-PL_2003",
  "US-AK_DrivingLicense-PL_2014",
  "US-AK_DrivingLicense-PL_2018",
  "US-AK_ID",
  "US-AK_IDCard_2003",
  "US-AK_IDCard_2014",
  "US-AK_IDCard_2018",
  "US-AK_IDCard-PL_2018",
  "US-AK",
  "US-AL_DL",
  "US-AL_DrivingLicense_1997",
  "US-AL_DrivingLicense_2005",
  "US-AL_DrivingLicense_2009",
  "US-AL_DrivingLicense_2013",
  "US-AL_DrivingLicense_YYYY",
  "US-AL_DrivingLicense-PL_1997",
  "US-AL_DrivingLicense-PL_2005",
  "US-AL_DrivingLicense-PL_2009",
  "US-AL_DrivingLicense-PL_2014",
  "US-AL_ID",
  "US-AL_IDCard_1997",
  "US-AL_IDCard_2005",
  "US-AL_IDCard_2009",
  "US-AL_IDCard_2013",
  "US-AL_IDCard-PL_1997",
  "US-AL_IDCard-PL_2005",
  "US-AL_IDCard-PL_2009",
  "US-AL_IDCard-PL_2014",
  "US-AL",
  "US-AR_DL",
  "US-AR_DrivingLicense_2001",
  "US-AR_DrivingLicense_2016",
  "US-AR_DrivingLicense_2018",
  "US-AR_DrivingLicense-PL_2001",
  "US-AR_DrivingLicense-PL_2012",
  "US-AR_DrivingLicense-PL_2018",
  "US-AR_ID",
  "US-AR_IDCard_2001",
  "US-AR_IDCard_2012",
  "US-AR_IDCard_2018",
  "US-AR_IDCard-PL_2001",
  "US-AR_IDCard-PL_2012",
  "US-AR_IDCard-PL_2018",
  "US-AR_IDCard-PL_YYYY",
  "US-AR",
  "US-AZ_DL",
  "US-AZ_DrivingLicense_1990",
  "US-AZ_DrivingLicense_1994",
  "US-AZ_DrivingLicense_1996",
  "US-AZ_DrivingLicense_2001",
  "US-AZ_DrivingLicense_2004",
  "US-AZ_DrivingLicense_2016",
  "US-AZ_DrivingLicense_2023",
  "US-AZ_DrivingLicense-PL_1996",
  "US-AZ_DrivingLicense-PL_2001",
  "US-AZ_DrivingLicense-PL_2014",
  "US-AZ_DrivingLicense-PL_2023",
  "US-AZ_ID",
  "US-AZ_IDCard_1996",
  "US-AZ_IDCard_2001",
  "US-AZ_IDCard_2014",
  "US-AZ_IDCard_2023",
  "US-AZ_IDCard-PL_2001",
  "US-AZ_IDCard-PL_2014",
  "US-AZ_IDCard-PL_2023",
  "US-AZ",
  "US-CA_DL",
  "US-CA_DrivingLicense_2002",
  "US-CA_DrivingLicense_2004",
  "US-CA_DrivingLicense_2008",
  "US-CA_DrivingLicense_2018",
  "US-CA_DrivingLicense-PL_2004",
  "US-CA_DrivingLicense-PL_2010",
  "US-CA_DrivingLicense-PL_2017",
  "US-CA_ID",
  "US-CA_IDCard_2004",
  "US-CA_IDCard_2010",
  "US-CA_IDCard_2017",
  "US-CA_IDCard_YYYY",
  "US-CA_IDCard-PL_2004",
  "US-CA_IDCard-PL_2010",
  "US-CA_IDCard-PL_2017",
  "US-CA",
  "US-CO_DL",
  "US-CO_DrivingLicense_2000",
  "US-CO_DrivingLicense_2004",
  "US-CO_DrivingLicense_2011",
  "US-CO_DrivingLicense_2016",
  "US-CO_DrivingLicense_2020",
  "US-CO_DrivingLicense_2022",
  "US-CO_DrivingLicense-PL_2000",
  "US-CO_DrivingLicense-PL_2004",
  "US-CO_DrivingLicense-PL_2013",
  "US-CO_DrivingLicense-PL_2015",
  "US-CO_DrivingLicense-PL_2020",
  "US-CO_DrivingLicense-PL_2022",
  "US-CO_ID",
  "US-CO_IDCard_2000",
  "US-CO_IDCard_2004",
  "US-CO_IDCard_2013",
  "US-CO_IDCard_2015",
  "US-CO_IDCard_2020",
  "US-CO_IDCard_2022",
  "US-CO_IDCard-PL_2004",
  "US-CO_IDCard-PL_2015",
  "US-CO_IDCard-PL_2022",
  "US-CO",
  "US-CT_DL",
  "US-CT_DrivingLicense_2002",
  "US-CT_DrivingLicense_2009",
  "US-CT_DrivingLicense_2012",
  "US-CT_DrivingLicense_2017",
  "US-CT_DrivingLicense-PL_2002",
  "US-CT_DrivingLicense-PL_2009",
  "US-CT_DrivingLicense-PL_2012",
  "US-CT_DrivingLicense-PL_2017",
  "US-CT_ID",
  "US-CT_IDCard_2002",
  "US-CT_IDCard_2009",
  "US-CT_IDCard_2012",
  "US-CT_IDCard_2017",
  "US-CT_IDCard-PL_2009",
  "US-CT_IDCard-PL_2012",
  "US-CT_IDCard-PL_2017",
  "US-CT",
  "US-DC_DL",
  "US-DC_DrivingLicense_2003",
  "US-DC_DrivingLicense_2013",
  "US-DC_DrivingLicense_2017",
  "US-DC_DrivingLicense_2023",
  "US-DC_DrivingLicense-PL_2003",
  "US-DC_DrivingLicense-PL_2013",
  "US-DC_DrivingLicense-PL_2017",
  "US-DC_DrivingLicense-PL_2023",
  "US-DC_ID",
  "US-DC_IDCard_2003",
  "US-DC_IDCard_2013",
  "US-DC_IDCard_2017",
  "US-DC_IDCard_2023",
  "US-DC_IDCard-PL_2003",
  "US-DC_IDCard-PL_2017",
  "US-DC_IDCard-PL_2023",
  "US-DC",
  "US-DE_DL",
  "US-DE_DrivingLicense_2003",
  "US-DE_DrivingLicense_2010",
  "US-DE_DrivingLicense_2018",
  "US-DE_DrivingLicense-PL_2003",
  "US-DE_DrivingLicense-PL_2010",
  "US-DE_DrivingLicense-PL_2017",
  "US-DE_ID",
  "US-DE_IDCard_2003",
  "US-DE_IDCard_2010",
  "US-DE_IDCard_2017",
  "US-DE_IDCard-PL_2010",
  "US-DE_IDCard-PL_2017",
  "US-DE",
  "US-FL_DL",
  "US-FL_DrivingLicense_1990",
  "US-FL_DrivingLicense_1995",
  "US-FL_DrivingLicense_2004",
  "US-FL_DrivingLicense_2009",
  "US-FL_DrivingLicense_2010",
  "US-FL_DrivingLicense_2017",
  "US-FL_DrivingLicense-PL_1995",
  "US-FL_DrivingLicense-PL_2004",
  "US-FL_DrivingLicense-PL_2009",
  "US-FL_DrivingLicense-PL_2012",
  "US-FL_DrivingLicense-PL_2017",
  "US-FL_ID",
  "US-FL_IDCard_1995",
  "US-FL_IDCard_2004",
  "US-FL_IDCard_2009",
  "US-FL_IDCard_2012",
  "US-FL_IDCard_2017",
  "US-FL_IDCard_YYYY",
  "US-FL_IDCard-PL_2004",
  "US-FL_IDCard-PL_2009",
  "US-FL_IDCard-PL_2012",
  "US-FL_IDCard-PL_2017",
  "US-FL",
  "US-GA_DL",
  "US-GA_DrivingLicense_1998",
  "US-GA_DrivingLicense_2007",
  "US-GA_DrivingLicense_2009",
  "US-GA_DrivingLicense_2012",
  "US-GA_DrivingLicense_2019",
  "US-GA_DrivingLicense-PL_1998",
  "US-GA_DrivingLicense-PL_2007",
  "US-GA_DrivingLicense-PL_2009",
  "US-GA_DrivingLicense-PL_2012",
  "US-GA_DrivingLicense-PL_2019",
  "US-GA_ID",
  "US-GA_IDCard_1998",
  "US-GA_IDCard_2007",
  "US-GA_IDCard_2009",
  "US-GA_IDCard_2012",
  "US-GA_IDCard_2019",
  "US-GA_IDCard_YYYY",
  "US-GA_IDCard-PL_2007",
  "US-GA_IDCard-PL_2009",
  "US-GA_IDCard-PL_2012",
  "US-GA_IDCard-PL_2019",
  "US-GA",
  "US-HI_DL",
  "US-HI_DrivingLicense_2001",
  "US-HI_DrivingLicense_2005",
  "US-HI_DrivingLicense_2012",
  "US-HI_DrivingLicense_2018",
  "US-HI_DrivingLicense_2020",
  "US-HI_DrivingLicense-PL_2005",
  "US-HI_DrivingLicense-PL_2010",
  "US-HI_DrivingLicense-PL_2018",
  "US-HI_DrivingLicense-PL_2020",
  "US-HI_ID",
  "US-HI_IDCard_2009",
  "US-HI_IDCard_2010",
  "US-HI_IDCard_2018",
  "US-HI_IDCard_2020",
  "US-HI_IDCard-PL_2009",
  "US-HI_IDCard-PL_2010",
  "US-HI",
  "US-IA_DL",
  "US-IA_DrivingLicense_2005",
  "US-IA_DrivingLicense_2013",
  "US-IA_DrivingLicense_2018",
  "US-IA_DrivingLicense-PL_2005",
  "US-IA_DrivingLicense-PL_2010",
  "US-IA_DrivingLicense-PL_2017",
  "US-IA_ID",
  "US-IA_IDCard_2005",
  "US-IA_IDCard_2010",
  "US-IA_IDCard_2017",
  "US-IA_IDCard-PL_2005",
  "US-IA_IDCard-PL_2010",
  "US-IA_IDCard-PL_2017",
  "US-IA",
  "US-ID_DL",
  "US-ID_DrivingLicense_2003",
  "US-ID_DrivingLicense_2004",
  "US-ID_DrivingLicense_2005",
  "US-ID_DrivingLicense_2010",
  "US-ID_DrivingLicense_2017",
  "US-ID_DrivingLicense_2023",
  "US-ID_DrivingLicense-PL_2003",
  "US-ID_DrivingLicense-PL_2011",
  "US-ID_DrivingLicense-PL_2016",
  "US-ID_DrivingLicense-PL_2023",
  "US-ID_ID",
  "US-ID_IDCard_2003",
  "US-ID_IDCard_2005",
  "US-ID_IDCard_2011",
  "US-ID_IDCard_2016",
  "US-ID_IDCard_2023",
  "US-ID_IDCard-PL_2016",
  "US-ID_IDCard-PL_2023",
  "US-ID",
  "US-IL_DL",
  "US-IL_DrivingLicense_2000",
  "US-IL_DrivingLicense_2007",
  "US-IL_DrivingLicense_2016",
  "US-IL_DrivingLicense_YYYY",
  "US-IL_DrivingLicense-PL_2000",
  "US-IL_DrivingLicense-PL_2007",
  "US-IL_DrivingLicense-PL_2015",
  "US-IL_ID",
  "US-IL_IDCard_2000",
  "US-IL_IDCard_2007",
  "US-IL_IDCard_2015",
  "US-IL_IDCard_2022",
  "US-IL_IDCard_YYYY",
  "US-IL_IDCard-PL_2000",
  "US-IL_IDCard-PL_2007",
  "US-IL_IDCard-PL_2015",
  "US-IL",
  "US-IN_DL",
  "US-IN_DrivingLicense_1999",
  "US-IN_DrivingLicense_2007",
  "US-IN_DrivingLicense_2010",
  "US-IN_DrivingLicense_2017",
  "US-IN_DrivingLicense-PL_1999",
  "US-IN_DrivingLicense-PL_2007",
  "US-IN_DrivingLicense-PL_2009",
  "US-IN_DrivingLicense-PL_2018",
  "US-IN_ID",
  "US-IN_IDCard_1999",
  "US-IN_IDCard_2007",
  "US-IN_IDCard_2009",
  "US-IN_IDCard_2018",
  "US-IN_IDCard-PL_1999",
  "US-IN_IDCard-PL_2007",
  "US-IN_IDCard-PL_2009",
  "US-IN_IDCard-PL_2018",
  "US-IN",
  "US-KS_DL",
  "US-KS_DrivingLicense_2004",
  "US-KS_DrivingLicense_2012",
  "US-KS_DrivingLicense_2017",
  "US-KS_DrivingLicense-PL_2004",
  "US-KS_DrivingLicense-PL_2012",
  "US-KS_DrivingLicense-PL_2017",
  "US-KS_ID",
  "US-KS_IDCard_2001",
  "US-KS_IDCard_2004",
  "US-KS_IDCard_2012",
  "US-KS_IDCard_2017",
  "US-KS_IDCard-PL_2004",
  "US-KS_IDCard-PL_2012",
  "US-KS_IDCard-PL_2017",
  "US-KS",
  "US-KY_DL",
  "US-KY_DrivingLicense_2002",
  "US-KY_DrivingLicense_2008",
  "US-KY_DrivingLicense_2012",
  "US-KY_DrivingLicense_2019",
  "US-KY_DrivingLicense-PL_2002",
  "US-KY_DrivingLicense-PL_2008",
  "US-KY_DrivingLicense-PL_2012",
  "US-KY_DrivingLicense-PL_2019",
  "US-KY_ID",
  "US-KY_IDCard_2008",
  "US-KY_IDCard_2012",
  "US-KY_IDCard_2019",
  "US-KY_IDCard-PL_2008",
  "US-KY_IDCard-PL_2019",
  "US-KY",
  "US-LA_DL",
  "US-LA_DrivingLicense_2011",
  "US-LA_DrivingLicense_2014",
  "US-LA_DrivingLicense_2016",
  "US-LA_DrivingLicense-PL_2001",
  "US-LA_DrivingLicense-PL_2015",
  "US-LA_ID",
  "US-LA_IDCard_2001",
  "US-LA_IDCard_2014",
  "US-LA_IDCard_2015",
  "US-LA_IDCard-PL_2001",
  "US-LA_IDCard-PL_2015",
  "US-LA",
  "US-MA_DL",
  "US-MA_DrivingLicense_2000",
  "US-MA_DrivingLicense_2004",
  "US-MA_DrivingLicense_2009",
  "US-MA_DrivingLicense_2010",
  "US-MA_DrivingLicense_2018",
  "US-MA_DrivingLicense-PL_1994",
  "US-MA_DrivingLicense-PL_2000",
  "US-MA_DrivingLicense-PL_2004",
  "US-MA_DrivingLicense-PL_2009",
  "US-MA_DrivingLicense-PL_2016",
  "US-MA_ID",
  "US-MA_IDCard_1994",
  "US-MA_IDCard_2000",
  "US-MA_IDCard_2004",
  "US-MA_IDCard_2009",
  "US-MA_IDCard_2016",
  "US-MA_IDCard-PL_2004",
  "US-MA_IDCard-PL_2009",
  "US-MA_IDCard-PL_2016",
  "US-MA",
  "US-MD_DL",
  "US-MD_DrivingLicense_2013",
  "US-MD_DrivingLicense_2016",
  "US-MD_DrivingLicense_YYYY",
  "US-MD_DrivingLicense-PL_2002",
  "US-MD_DrivingLicense-PL_2016",
  "US-MD_ID",
  "US-MD_IDCard_2002",
  "US-MD_IDCard_2016",
  "US-MD_IDCard-PL_2002",
  "US-MD_IDCard-PL_2016",
  "US-MD",
  "US-ME_DL",
  "US-ME_DrivingLicense_1999",
  "US-ME_DrivingLicense_2011",
  "US-ME_DrivingLicense_2019",
  "US-ME_DrivingLicense-PL_1999",
  "US-ME_DrivingLicense-PL_2011",
  "US-ME_DrivingLicense-PL_2019",
  "US-ME_ID",
  "US-ME_IDCard_1999",
  "US-ME_IDCard_2011",
  "US-ME_IDCard_2019",
  "US-ME_IDCard-PL_1999",
  "US-ME_IDCard-PL_2011",
  "US-ME_IDCard-PL_2019",
  "US-ME",
  "US-MI_DL",
  "US-MI_DrivingLicense_2001",
  "US-MI_DrivingLicense_2009",
  "US-MI_DrivingLicense_2017",
  "US-MI_DrivingLicense_2024",
  "US-MI_DrivingLicense-PL_2001",
  "US-MI_DrivingLicense-PL_2009",
  "US-MI_DrivingLicense-PL_2011",
  "US-MI_DrivingLicense-PL_2024",
  "US-MI_ID",
  "US-MI_IDCard_2001",
  "US-MI_IDCard_2009",
  "US-MI_IDCard_2011",
  "US-MI_IDCard-PL_2001",
  "US-MI_IDCard-PL_2009",
  "US-MI_IDCard-PL_2011",
  "US-MI_IDCard-PL_2024",
  "US-MI",
  "US-MN_DL",
  "US-MN_DrivingLicense_2004",
  "US-MN_DrivingLicense_2014",
  "US-MN_DrivingLicense_2018",
  "US-MN_DrivingLicense_YYYY",
  "US-MN_DrivingLicense-PL_2004",
  "US-MN_DrivingLicense-PL_2018",
  "US-MN_ID",
  "US-MN_IDCard_2004",
  "US-MN_IDCard_2018",
  "US-MN_IDCard-PL_2004",
  "US-MN_IDCard-PL_2014",
  "US-MN_IDCard-PL_2018",
  "US-MN",
  "US-MO_DL",
  "US-MO_DrivingLicense_2004",
  "US-MO_DrivingLicense_2012",
  "US-MO_DrivingLicense_2020",
  "US-MO_DrivingLicense-PL_2003",
  "US-MO_DrivingLicense-PL_2012",
  "US-MO_DrivingLicense-PL_2020",
  "US-MO_ID",
  "US-MO_IDCard_2003",
  "US-MO_IDCard_2012",
  "US-MO_IDCard_2020",
  "US-MO_IDCard-PL_2003",
  "US-MO_IDCard-PL_2012",
  "US-MO_IDCard-PL_2020",
  "US-MO",
  "US-MS_DL",
  "US-MS_DrivingLicense_2001",
  "US-MS_DrivingLicense_2017",
  "US-MS_DrivingLicense_2024",
  "US-MS_DrivingLicense_YYYY",
  "US-MS_DrivingLicense-PL_2001",
  "US-MS_DrivingLicense-PL_2016",
  "US-MS_DrivingLicense-PL_2024",
  "US-MS_ID",
  "US-MS_IDCard_2001",
  "US-MS_IDCard_2016",
  "US-MS_IDCard_2024",
  "US-MS_IDCard-PL_2001",
  "US-MS_IDCard-PL_2016",
  "US-MS",
  "US-MT_DL",
  "US-MT_DrivingLicense_2000",
  "US-MT_DrivingLicense_2003",
  "US-MT_DrivingLicense_2008",
  "US-MT_DrivingLicense-PL_2003",
  "US-MT_DrivingLicense-PL_2008",
  "US-MT_DrivingLicense-PL_2015",
  "US-MT_ID",
  "US-MT_IDCard_2003",
  "US-MT_IDCard_2008",
  "US-MT_IDCard_2015",
  "US-MT_IDCard-PL_2008",
  "US-MT_IDCard-PL_2015",
  "US-MT",
  "US-NC_DL",
  "US-NC_DrivingLicense_2004",
  "US-NC_DrivingLicense_2007",
  "US-NC_DrivingLicense_2014",
  "US-NC_DrivingLicense_2017",
  "US-NC_DrivingLicense_2024",
  "US-NC_DrivingLicense-PL_2000",
  "US-NC_DrivingLicense-PL_2004",
  "US-NC_DrivingLicense-PL_2008",
  "US-NC_DrivingLicense-PL_2014",
  "US-NC_DrivingLicense-PL_2017",
  "US-NC_DrivingLicense-PL_2024",
  "US-NC_ID",
  "US-NC_IDCard_2004",
  "US-NC_IDCard_2014",
  "US-NC_IDCard_2017",
  "US-NC_IDCard_2024",
  "US-NC_IDCard-PL_2000",
  "US-NC_IDCard-PL_2004",
  "US-NC_IDCard-PL_2008",
  "US-NC_IDCard-PL_2014",
  "US-NC_IDCard-PL_2017",
  "US-NC_IDCard-PL_2024",
  "US-NC",
  "US-ND_DL",
  "US-ND_DrivingLicense_2006",
  "US-ND_DrivingLicense_2018",
  "US-ND_DrivingLicense_2023",
  "US-ND_DrivingLicense-PL_2006",
  "US-ND_DrivingLicense-PL_2014",
  "US-ND_ID",
  "US-ND_IDCard_2000",
  "US-ND_IDCard_2006",
  "US-ND_IDCard_2014",
  "US-ND_IDCard_2023",
  "US-ND_IDCard-PL_2014",
  "US-ND_IDCard-PL_2023",
  "US-ND",
  "US-NE_DL",
  "US-NE_DrivingLicense_1997",
  "US-NE_DrivingLicense_2003",
  "US-NE_DrivingLicense_2009",
  "US-NE_DrivingLicense_2013",
  "US-NE_DrivingLicense_2021",
  "US-NE_DrivingLicense-PL_2003",
  "US-NE_DrivingLicense-PL_2009",
  "US-NE_DrivingLicense-PL_2021",
  "US-NE_ID",
  "US-NE_IDCard_2003",
  "US-NE_IDCard_2009",
  "US-NE_IDCard_2021",
  "US-NE_IDCard-PL_2003",
  "US-NE_IDCard-PL_2009",
  "US-NE_IDCard-PL_2021",
  "US-NE",
  "US-NH_DL",
  "US-NH_DrivingLicense_1999",
  "US-NH_DrivingLicense_2006",
  "US-NH_DrivingLicense_2017",
  "US-NH_DrivingLicense-PL_1999",
  "US-NH_DrivingLicense-PL_2008",
  "US-NH_DrivingLicense-PL_2017",
  "US-NH_ID",
  "US-NH_IDCard_2008",
  "US-NH_IDCard_2017",
  "US-NH_IDCard-PL_2017",
  "US-NH",
  "US-NJ_DL",
  "US-NJ_DrivingLicense_1997",
  "US-NJ_DrivingLicense_2004",
  "US-NJ_DrivingLicense_2010",
  "US-NJ_DrivingLicense_2011",
  "US-NJ_DrivingLicense_2020",
  "US-NJ_DrivingLicense-PL_2004",
  "US-NJ_DrivingLicense-PL_2010",
  "US-NJ_DrivingLicense-PL_2019",
  "US-NJ_DrivingLicense-PL_2020",
  "US-NJ_HC",
  "US-NJ_HealthCard_YYYY",
  "US-NJ_ID",
  "US-NJ_IDCard_2004",
  "US-NJ_IDCard_2010",
  "US-NJ_IDCard_2019",
  "US-NJ_IDCard_2020",
  "US-NJ_IDCard-PL_2004",
  "US-NJ_IDCard-PL_2010",
  "US-NJ_IDCard-PL_2020",
  "US-NJ",
  "US-NM_DL",
  "US-NM_DrivingLicense_2001",
  "US-NM_DrivingLicense_2007",
  "US-NM_DrivingLicense_2014",
  "US-NM_DrivingLicense_2016",
  "US-NM_DrivingLicense_2019",
  "US-NM_DrivingLicense_YYYY",
  "US-NM_DrivingLicense-PL_2007",
  "US-NM_DrivingLicense-PL_2015",
  "US-NM_DrivingLicense-PL_2019",
  "US-NM_ID",
  "US-NM_IDCard_2001",
  "US-NM_IDCard_2007",
  "US-NM_IDCard_2015",
  "US-NM_IDCard_2019",
  "US-NM_IDCard-PL_2001",
  "US-NM_IDCard-PL_2007",
  "US-NM",
  "US-NV_DL",
  "US-NV_DrivingLicense_2002",
  "US-NV_DrivingLicense_2008",
  "US-NV_DrivingLicense_2010",
  "US-NV_DrivingLicense_2014",
  "US-NV_DrivingLicense_2015",
  "US-NV_DrivingLicense_2021",
  "US-NV_DrivingLicense-PL_2002",
  "US-NV_DrivingLicense-PL_2008",
  "US-NV_DrivingLicense-PL_2010",
  "US-NV_DrivingLicense-PL_2012",
  "US-NV_DrivingLicense-PL_2013",
  "US-NV_DrivingLicense-PL_2015",
  "US-NV_DrivingLicense-PL_2021",
  "US-NV_ID",
  "US-NV_IDCard_1999",
  "US-NV_IDCard_2002",
  "US-NV_IDCard_2008",
  "US-NV_IDCard_2010",
  "US-NV_IDCard_2012",
  "US-NV_IDCard_2015",
  "US-NV_IDCard_2021",
  "US-NV_IDCard_YYYY",
  "US-NV_IDCard-PL_2002",
  "US-NV_IDCard-PL_2008",
  "US-NV_IDCard-PL_2010",
  "US-NV_IDCard-PL_2012",
  "US-NV_IDCard-PL_2015",
  "US-NV_IDCard-PL_2021",
  "US-NV",
  "US-NY_DL",
  "US-NY_DrivingLicense_1992",
  "US-NY_DrivingLicense_1996",
  "US-NY_DrivingLicense_1998",
  "US-NY_DrivingLicense_2005",
  "US-NY_DrivingLicense_2008",
  "US-NY_DrivingLicense_2013",
  "US-NY_DrivingLicense_2017",
  "US-NY_DrivingLicense_2022",
  "US-NY_DrivingLicense-PL_1992",
  "US-NY_DrivingLicense-PL_1996",
  "US-NY_DrivingLicense-PL_2005",
  "US-NY_DrivingLicense-PL_2013",
  "US-NY_DrivingLicense-PL_2014",
  "US-NY_DrivingLicense-PL_2017",
  "US-NY_DrivingLicense-PL_2022",
  "US-NY_ID",
  "US-NY_IDCard_1996",
  "US-NY_IDCard_2005",
  "US-NY_IDCard_2013",
  "US-NY_IDCard_2015",
  "US-NY_IDCard_2017",
  "US-NY_IDCard_2019",
  "US-NY_IDCard_2022",
  "US-NY_IDCard_YYYY",
  "US-NY_IDCard-PL_2005",
  "US-NY_IDCard-PL_2013",
  "US-NY_IDCard-PL_2017",
  "US-NY_IDCard-PL_2022",
  "US-NY",
  "US-OH_DL",
  "US-OH_DrivingLicense_2006",
  "US-OH_DrivingLicense_2008",
  "US-OH_DrivingLicense_2013",
  "US-OH_DrivingLicense_2014",
  "US-OH_DrivingLicense_2018",
  "US-OH_DrivingLicense-PL_2006",
  "US-OH_DrivingLicense-PL_2008",
  "US-OH_DrivingLicense-PL_2009",
  "US-OH_DrivingLicense-PL_2015",
  "US-OH_DrivingLicense-PL_2018",
  "US-OH_ID",
  "US-OH_IDCard_2006",
  "US-OH_IDCard_2008",
  "US-OH_IDCard_2009",
  "US-OH_IDCard_2015",
  "US-OH_IDCard_2018",
  "US-OH_IDCard-PL_2006",
  "US-OH_IDCard-PL_2008",
  "US-OH_IDCard-PL_2009",
  "US-OH_IDCard-PL_2015",
  "US-OH_IDCard-PL_2018",
  "US-OH",
  "US-OK_DL",
  "US-OK_DrivingLicense_2003",
  "US-OK_DrivingLicense_2018",
  "US-OK_DrivingLicense_2020",
  "US-OK_DrivingLicense-PL_2003",
  "US-OK_DrivingLicense-PL_2012",
  "US-OK_DrivingLicense-PL_2020",
  "US-OK_ID",
  "US-OK_IDCard_2003",
  "US-OK_IDCard_2012",
  "US-OK_IDCard_2020",
  "US-OK_IDCard-PL_2003",
  "US-OK_IDCard-PL_2012",
  "US-OK",
  "US-OR_DL",
  "US-OR_DrivingLicense_1996",
  "US-OR_DrivingLicense_2004",
  "US-OR_DrivingLicense_2007",
  "US-OR_DrivingLicense_2018",
  "US-OR_DrivingLicense_2020",
  "US-OR_DrivingLicense-PL_1996",
  "US-OR_DrivingLicense-PL_2004",
  "US-OR_DrivingLicense-PL_2007",
  "US-OR_DrivingLicense-PL_2018",
  "US-OR_DrivingLicense-PL_2020",
  "US-OR_ID",
  "US-OR_IDCard_1996",
  "US-OR_IDCard_2004",
  "US-OR_IDCard_2007",
  "US-OR_IDCard_2018",
  "US-OR_IDCard_2020",
  "US-OR_IDCard-PL_2007",
  "US-OR_IDCard-PL_2018",
  "US-OR_IDCard-PL_2020",
  "US-OR",
  "US-PA_DL",
  "US-PA_DrivingLicense_2001",
  "US-PA_DrivingLicense_2011",
  "US-PA_DrivingLicense_2017",
  "US-PA_DrivingLicense_2019",
  "US-PA_DrivingLicense_2022",
  "US-PA_DrivingLicense-PL_2005",
  "US-PA_DrivingLicense-PL_2016",
  "US-PA_DrivingLicense-PL_2019",
  "US-PA_DrivingLicense-PL_2022",
  "US-PA_ID",
  "US-PA_IDCard_1998",
  "US-PA_IDCard_2001",
  "US-PA_IDCard_2005",
  "US-PA_IDCard_2016",
  "US-PA_IDCard_2019",
  "US-PA_IDCard_2022",
  "US-PA_IDCard-PL_2005",
  "US-PA_IDCard-PL_2016",
  "US-PA_IDCard-PL_2019",
  "US-PA_IDCard-PL_2022",
  "US-PA",
  "US-RI_DL",
  "US-RI_DrivingLicense_2007",
  "US-RI_DrivingLicense_2008",
  "US-RI_DrivingLicense_2018",
  "US-RI_DrivingLicense_YYYY",
  "US-RI_DrivingLicense-PL_2000",
  "US-RI_DrivingLicense-PL_2007",
  "US-RI_DrivingLicense-PL_2016",
  "US-RI_ID",
  "US-RI_IDCard_2007",
  "US-RI_IDCard_2016",
  "US-RI_IDCard-PL_2016",
  "US-RI",
  "US-SC_DL",
  "US-SC_DrivingLicense_2003",
  "US-SC_DrivingLicense_2011",
  "US-SC_DrivingLicense_2018",
  "US-SC_DrivingLicense-PL_2003",
  "US-SC_DrivingLicense-PL_2010",
  "US-SC_DrivingLicense-PL_2018",
  "US-SC_ID",
  "US-SC_IDCard_2003",
  "US-SC_IDCard_2010",
  "US-SC_IDCard_2018",
  "US-SC_IDCard-PL_2003",
  "US-SC_IDCard-PL_2010",
  "US-SC_IDCard-PL_2018",
  "US-SC",
  "US-SD_DL",
  "US-SD_DrivingLicense_2000",
  "US-SD_DrivingLicense_2010",
  "US-SD_DrivingLicense_2017",
  "US-SD_DrivingLicense-PL_2000",
  "US-SD_DrivingLicense-PL_2009",
  "US-SD_DrivingLicense-PL_2017",
  "US-SD_ID",
  "US-SD_IDCard_2000",
  "US-SD_IDCard_2009",
  "US-SD_IDCard_2017",
  "US-SD_IDCard-PL_2009",
  "US-SD_IDCard-PL_2017",
  "US-SD",
  "US-TN_DL",
  "US-TN_DrivingLicense_2003",
  "US-TN_DrivingLicense_2009",
  "US-TN_DrivingLicense_2011",
  "US-TN_DrivingLicense_2012",
  "US-TN_DrivingLicense_2019",
  "US-TN_DrivingLicense-PL_2003",
  "US-TN_DrivingLicense-PL_2009",
  "US-TN_DrivingLicense-PL_2010",
  "US-TN_DrivingLicense-PL_2011",
  "US-TN_DrivingLicense-PL_2018",
  "US-TN_DrivingLicense-PL_2019",
  "US-TN_ID",
  "US-TN_IDCard_2003",
  "US-TN_IDCard_2010",
  "US-TN_IDCard_2011",
  "US-TN_IDCard_2019",
  "US-TN_IDCard-PL_2003",
  "US-TN_IDCard-PL_2010",
  "US-TN_IDCard-PL_2011",
  "US-TN_IDCard-PL_2019",
  "US-TN",
  "US-TX_DL",
  "US-TX_DrivingLicense_2002",
  "US-TX_DrivingLicense_2007",
  "US-TX_DrivingLicense_2016",
  "US-TX_DrivingLicense_2020",
  "US-TX_DrivingLicense-PL_2002",
  "US-TX_DrivingLicense-PL_2007",
  "US-TX_DrivingLicense-PL_2016",
  "US-TX_DrivingLicense-PL_2020",
  "US-TX_ID",
  "US-TX_IDCard_2002",
  "US-TX_IDCard_2007",
  "US-TX_IDCard_2016",
  "US-TX_IDCard_2020",
  "US-TX_IDCard_YYYY",
  "US-TX_IDCard-PL_2002",
  "US-TX_IDCard-PL_2007",
  "US-TX_IDCard-PL_2016",
  "US-TX_IDCard-PL_2020",
  "US-TX",
  "US-UT_DL",
  "US-UT_DrivingLicense_2001",
  "US-UT_DrivingLicense_2006",
  "US-UT_DrivingLicense_2016",
  "US-UT_DrivingLicense_2021",
  "US-UT_DrivingLicense-PL_2001",
  "US-UT_DrivingLicense-PL_2006",
  "US-UT_DrivingLicense-PL_2013",
  "US-UT_DrivingLicense-PL_2016",
  "US-UT_DrivingLicense-PL_2021",
  "US-UT_ID",
  "US-UT_IDCard_2001",
  "US-UT_IDCard_2006",
  "US-UT_IDCard_2016",
  "US-UT_IDCard_2021",
  "US-UT_IDCard-PL_2001",
  "US-UT_IDCard-PL_2016",
  "US-UT_IDCard-PL_2021",
  "US-UT",
  "US-VA_DL",
  "US-VA_DrivingLicense_1999",
  "US-VA_DrivingLicense_2018",
  "US-VA_DrivingLicense_2023",
  "US-VA_DrivingLicense-PL_1999",
  "US-VA_DrivingLicense-PL_2009",
  "US-VA_DrivingLicense-PL_2023",
  "US-VA_DrivingLicense-PL_YYYY",
  "US-VA_ID",
  "US-VA_IDCard_1999",
  "US-VA_IDCard_2018",
  "US-VA_IDCard_2023",
  "US-VA_IDCard-PL_1999",
  "US-VA_IDCard-PL_2009",
  "US-VA_IDCard-PL_2023",
  "US-VA",
  "US-VT_DL",
  "US-VT_DrivingLicense_2003",
  "US-VT_DrivingLicense_2009",
  "US-VT_DrivingLicense_2014",
  "US-VT_DrivingLicense_2018",
  "US-VT_DrivingLicense-PL_2003",
  "US-VT_DrivingLicense-PL_2009",
  "US-VT_DrivingLicense-PL_2014",
  "US-VT_DrivingLicense-PL_2018",
  "US-VT_ID",
  "US-VT_IDCard_2003",
  "US-VT_IDCard_2009",
  "US-VT_IDCard_2012",
  "US-VT_IDCard_2014",
  "US-VT_IDCard_2018",
  "US-VT_IDCard-PL_2014",
  "US-VT_IDCard-PL_2018",
  "US-VT",
  "US-WA_DL",
  "US-WA_DrivingLicense_2001",
  "US-WA_DrivingLicense_2007",
  "US-WA_DrivingLicense_2010",
  "US-WA_DrivingLicense_2017",
  "US-WA_DrivingLicense_2019",
  "US-WA_DrivingLicense-PL_2001",
  "US-WA_DrivingLicense-PL_2007",
  "US-WA_DrivingLicense-PL_2009",
  "US-WA_DrivingLicense-PL_2015",
  "US-WA_DrivingLicense-PL_2018",
  "US-WA_ID",
  "US-WA_IDCard_2001",
  "US-WA_IDCard_2007",
  "US-WA_IDCard_2009",
  "US-WA_IDCard_2015",
  "US-WA_IDCard_2018",
  "US-WA_IDCard-PL_2001",
  "US-WA_IDCard-PL_2007",
  "US-WA_IDCard-PL_2009",
  "US-WA_IDCard-PL_2015",
  "US-WA_IDCard-PL_2018",
  "US-WA",
  "US-WI_DL",
  "US-WI_DrivingLicense_2002",
  "US-WI_DrivingLicense_2005",
  "US-WI_DrivingLicense_2012",
  "US-WI_DrivingLicense_2015",
  "US-WI_DrivingLicense_2023",
  "US-WI_DrivingLicense-PL_2002",
  "US-WI_DrivingLicense-PL_2005",
  "US-WI_DrivingLicense-PL_2012",
  "US-WI_DrivingLicense-PL_2015",
  "US-WI_DrivingLicense-PL_2023",
  "US-WI_ID",
  "US-WI_IDCard_2002",
  "US-WI_IDCard_2005",
  "US-WI_IDCard_2012",
  "US-WI_IDCard_2015",
  "US-WI_IDCard_2023",
  "US-WI_IDCard-PL_2005",
  "US-WI_IDCard-PL_2012",
  "US-WI_IDCard-PL_2015",
  "US-WI_IDCard-PL_2023",
  "US-WI",
  "US-WV_DL",
  "US-WV_DrivingLicense_2005",
  "US-WV_DrivingLicense_2013",
  "US-WV_DrivingLicense_2019",
  "US-WV_DrivingLicense_2023",
  "US-WV_DrivingLicense-PL_2005",
  "US-WV_DrivingLicense-PL_2011",
  "US-WV_DrivingLicense-PL_2019",
  "US-WV_DrivingLicense-PL_2023",
  "US-WV_ID",
  "US-WV_IDCard_2005",
  "US-WV_IDCard_2011",
  "US-WV_IDCard_2019",
  "US-WV_IDCard_2023",
  "US-WV_IDCard-PL_2019",
  "US-WV_IDCard-PL_2023",
  "US-WV",
  "US-WY_DL",
  "US-WY_DrivingLicense_2004",
  "US-WY_DrivingLicense_2011",
  "US-WY_DrivingLicense_2014",
  "US-WY_DrivingLicense_2018",
  "US-WY_DrivingLicense_2023",
  "US-WY_DrivingLicense-PL_2004",
  "US-WY_DrivingLicense-PL_2010",
  "US-WY_DrivingLicense-PL_2011",
  "US-WY_DrivingLicense-PL_2018",
  "US-WY_ID",
  "US-WY_IDCard_2004",
  "US-WY_IDCard_2010",
  "US-WY_IDCard_2011",
  "US-WY_IDCard_2020",
  "US-WY_IDCard-PL_2004",
  "US-WY_IDCard-PL_2010",
  "US-WY",
  "US",
  "UY_DL",
  "UY_DrivingLicense_2015",
  "UY_DrivingLicense_2017",
  "UY_DrivingLicense_YYYY",
  "UY_ID",
  "UY_IDCard_1999",
  "UY_IDCard_2015",
  "UY",
  "UZ_DL",
  "UZ_DrivingLicense_2011",
  "UZ_DrivingLicense_2017",
  "UZ_DrivingLicense_YYYY",
  "UZ_ID",
  "UZ_IDCard_2021",
  "UZ_IDCard-Military_YYYY",
  "UZ_ResidencePermit_YYYY",
  "UZ",
  "VA_DL",
  "VA_DrivingLicense_YYYY",
  "VA",
  "VC_DL",
  "VC_DrivingLicense_YYYY",
  "VC_ID",
  "VC_IDCard_YYYY",
  "VC",
  "VE_DL",
  "VE_DrivingLicense_2008",
  "VE_DrivingLicense_2017",
  "VE_DrivingLicense_YYYY",
  "VE_ID",
  "VE_IDCard_2011",
  "VE_IDCard_YYYY",
  "VE",
  "VG_DL",
  "VG_DrivingLicense_YYYY",
  "VG",
  "VI_DL",
  "VI_DrivingLicense_2006",
  "VI_DrivingLicense_2018",
  "VI_DrivingLicense_2019",
  "VI_DrivingLicense_YYYY",
  "VI_DrivingLicense-PL_2006",
  "VI_DrivingLicense-PL_2018",
  "VI_DrivingLicense-PL_2019",
  "VI_ID",
  "VI_IDCard_2018",
  "VI_IDCard_2019",
  "VI_IDCard-PL_2019",
  "VI",
  "VN_DL",
  "VN_DrivingLicense_1993",
  "VN_DrivingLicense_2008",
  "VN_DrivingLicense_2012",
  "VN_ID",
  "VN_IDCard_2012",
  "VN_IDCard_2016",
  "VN_IDCard_2021",
  "VN_IDCard_YYYY",
  "VN_IDCard-Military_YYYY",
  "VN_ResidencePermit-PL_YYYY",
  "VN",
  "VU_DL",
  "VU_DrivingLicense_YYYY",
  "VU_ID",
  "VU_IDCard_2017",
  "VU_IDCard_2021",
  "VU_ResidencePermit_2011",
  "VU",
  "WS_DL",
  "WS_DrivingLicense_YYYY",
  "WS",
  "XX_DL",
  "XX_HC",
  "XX_ID",
  "XX_MRZType1_YYYY",
  "XX_Passport_YYYY",
  "XX_PC",
  "XX_XX_XXXX",
  "XX",
  "YE_DL",
  "YE_DrivingLicense_YYYY",
  "YE_ID",
  "YE_IDCard_YYYY",
  "YE",
  "ZA_DL",
  "ZA_DrivingLicense_2004",
  "ZA_DrivingLicense_YYYY",
  "ZA_DrivingLicense-PL_YYYY",
  "ZA_ID",
  "ZA_IDCard_2013",
  "ZA_ResidencePermit_YYYY",
  "ZA",
  "ZM_DL",
  "ZM_DrivingLicense_2016",
  "ZM_DrivingLicense_YYYY",
  "ZM_HC",
  "ZM_HealthCard_2021",
  "ZM_ID",
  "ZM_IDCard_YYYY",
  "ZM_ResidencePermit_2019",
  "ZM",
];

export const COUNTRY_DEFAULT_NAMINGS = {
  AD: "Andorra",
  AF: "Afghanistan",
  AI: "Anguilla",
  AL: "Albania",
  AO: "Angola",
  AE: "United Arab Emirates",
  AR: "Argentina",
  AM: "Armenia",
  AS: "American Samoa",
  AQ: "Antarctica",
  TF: "French Southern Territories",
  AG: "Antigua and Barbuda",
  AU: "Australia",
  AT: "Austria",
  AW: "Aruba",
  AX: "Åland Islands",
  AZ: "Azerbaijan",
  BI: "Burundi",
  BE: "Belgium",
  BJ: "Benin",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BF: "Burkina Faso",
  BD: "Bangladesh",
  BG: "Bulgaria",
  BH: "Bahrain",
  BS: "Bahamas",
  BA: "Bosnia and Herzegovina",
  BL: "Saint Barthélemy",
  BY: "Belarus",
  BZ: "Belize",
  BM: "Bermuda",
  BO: "Bolivia, Plurinational State of",
  BR: "Brazil",
  BB: "Barbados",
  BN: "Brunei Darussalam",
  BT: "Bhutan",
  BV: "Bouvet Island",
  BW: "Botswana",
  CF: "Central African Republic",
  CA: "Canada",
  CC: "Cocos (Keeling) Islands",
  CH: "Switzerland",
  CL: "Chile",
  CN: "China",
  CI: "Côte d'Ivoire",
  CM: "Cameroon",
  CD: "Congo, Democratic Republic of the",
  CG: "Congo",
  CK: "Cook Islands",
  CO: "Colombia",
  KM: "Comoros",
  CV: "Cabo Verde",
  CR: "Costa Rica",
  CU: "Cuba",
  CW: "Curaçao",
  CX: "Christmas Island",
  KY: "Cayman Islands",
  CY: "Cyprus",
  CZ: "Czechia",
  DE: "Germany",
  DJ: "Djibouti",
  DM: "Dominica",
  DK: "Denmark",
  DO: "Dominican Republic",
  DZ: "Algeria",
  EC: "Ecuador",
  EG: "Egypt",
  ER: "Eritrea",
  EH: "Western Sahara",
  ES: "Spain",
  EE: "Estonia",
  ET: "Ethiopia",
  FI: "Finland",
  FJ: "Fiji",
  FK: "Falkland Islands (Malvinas)",
  FR: "France",
  FO: "Faroe Islands",
  FM: "Micronesia, Federated States of",
  GA: "Gabon",
  GB: "United Kingdom of Great Britain and Northern Ireland",
  GE: "Georgia",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GN: "Guinea",
  GP: "Guadeloupe",
  GM: "Gambia",
  GW: "Guinea-Bissau",
  GQ: "Equatorial Guinea",
  GR: "Greece",
  GD: "Grenada",
  GL: "Greenland",
  GT: "Guatemala",
  GF: "French Guiana",
  GU: "Guam",
  GY: "Guyana",
  HK: "Hong Kong",
  HM: "Heard Island and McDonald Islands",
  HN: "Honduras",
  HR: "Croatia",
  HT: "Haiti",
  HU: "Hungary",
  ID: "Indonesia",
  IM: "Isle of Man",
  IN: "India",
  IO: "British Indian Ocean Territory",
  IE: "Ireland",
  IR: "Iran, Islamic Republic of",
  IQ: "Iraq",
  IS: "Iceland",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JE: "Jersey",
  JO: "Jordan",
  JP: "Japan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KG: "Kyrgyzstan",
  KH: "Cambodia",
  KI: "Kiribati",
  KN: "Saint Kitts and Nevis",
  KR: "Korea, Republic of",
  KW: "Kuwait",
  LA: "Lao People's Democratic Republic",
  LB: "Lebanon",
  LR: "Liberia",
  LY: "Libya",
  LC: "Saint Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LS: "Lesotho",
  LT: "Lithuania",
  LU: "Luxembourg",
  LV: "Latvia",
  MO: "Macao",
  MF: "Saint Martin (French part)",
  MA: "Morocco",
  MC: "Monaco",
  MD: "Moldova, Republic of",
  MG: "Madagascar",
  MV: "Maldives",
  MX: "Mexico",
  MH: "Marshall Islands",
  MK: "North Macedonia",
  ML: "Mali",
  MT: "Malta",
  MM: "Myanmar",
  ME: "Montenegro",
  MN: "Mongolia",
  MP: "Northern Mariana Islands",
  MZ: "Mozambique",
  MR: "Mauritania",
  MS: "Montserrat",
  MQ: "Martinique",
  MU: "Mauritius",
  MW: "Malawi",
  MY: "Malaysia",
  YT: "Mayotte",
  NA: "Namibia",
  NC: "New Caledonia",
  NE: "Niger",
  NF: "Norfolk Island",
  NG: "Nigeria",
  NI: "Nicaragua",
  NU: "Niue",
  NL: "Netherlands",
  NO: "Norway",
  NP: "Nepal",
  NR: "Nauru",
  NZ: "New Zealand",
  OM: "Oman",
  PK: "Pakistan",
  PA: "Panama",
  PN: "Pitcairn",
  PE: "Peru",
  PH: "Philippines",
  PW: "Palau",
  PG: "Papua New Guinea",
  PL: "Poland",
  PR: "Puerto Rico",
  KP: "Korea, Democratic People's Republic of",
  PT: "Portugal",
  PY: "Paraguay",
  PS: "Palestine, State of",
  PF: "French Polynesia",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Romania",
  RU: "Russian Federation",
  RW: "Rwanda",
  SA: "Saudi Arabia",
  SD: "Sudan",
  SN: "Senegal",
  SG: "Singapore",
  GS: "South Georgia and the South Sandwich Islands",
  SH: "Saint Helena, Ascension and Tristan da Cunha",
  SJ: "Svalbard and Jan Mayen",
  SB: "Solomon Islands",
  SL: "Sierra Leone",
  SV: "El Salvador",
  SM: "San Marino",
  SO: "Somalia",
  PM: "Saint Pierre and Miquelon",
  RS: "Serbia",
  SS: "South Sudan",
  ST: "Sao Tome and Principe",
  SR: "Suriname",
  SK: "Slovakia",
  SI: "Slovenia",
  SE: "Sweden",
  SZ: "Eswatini",
  SX: "Sint Maarten (Dutch part)",
  SC: "Seychelles",
  SY: "Syrian Arab Republic",
  TC: "Turks and Caicos Islands",
  TD: "Chad",
  TG: "Togo",
  TH: "Thailand",
  TJ: "Tajikistan",
  TK: "Tokelau",
  TM: "Turkmenistan",
  TL: "Timor-Leste",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TV: "Tuvalu",
  TW: "Taiwan, Province of China",
  TZ: "Tanzania, United Republic of",
  UG: "Uganda",
  UA: "Ukraine",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  US: "United States of America",
  UZ: "Uzbekistan",
  VA: "Holy See",
  VC: "Saint Vincent and the Grenadines",
  VE: "Venezuela, Bolivarian Republic of",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  VN: "Viet Nam",
  VU: "Vanuatu",
  WF: "Wallis and Futuna",
  WS: "Samoa",
  XK: "Kosovo",
  YE: "Yemen",
  ZA: "South Africa",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  "AU-ACT": "Australia - Australian Capital Territory",
  "AU-NSW": "Australia - New South Wales",
  "AU-NT": "Australia - Northern Territory",
  "AU-QLD": "Australia - Queensland",
  "AU-SA": "Australia - South Australia",
  "AU-TAS": "Australia - Tasmania",
  "AU-VIC": "Australia - Victoria",
  "AU-WA": "Australia - Western Australia",
  "CA-AB": "Canada - Alberta",
  "CA-BC": "Canada - British Columbia",
  "CA-MB": "Canada - Manitoba",
  "CA-NB": "Canada - New Brunswick",
  "CA-NL": "Canada - Newfoundland and Labrador",
  "CA-NS": "Canada - Nova Scotia",
  "CA-NT": "Canada - Northwest Territories",
  "CA-NU": "Canada - Nunavut",
  "CA-ON": "Canada - Ontario",
  "CA-PE": "Canada - Prince Edward Island",
  "CA-QC": "Canada - Quebec",
  "CA-SK": "Canada - Saskatchewan",
  "CA-YT": "Canada - Yukon",
  "MX-AGU": "Mexico - Aguascalientes",
  "MX-BCN": "Mexico - Baja California",
  "MX-BCS": "Mexico - Baja California Sur",
  "MX-CAM": "Mexico - Campeche",
  "MX-CHH": "Mexico - Chihuahua",
  "MX-CHP": "Mexico - Chiapas",
  "MX-CMX": "Mexico - Ciudad de México",
  "MX-COA": "Mexico - Coahuila de Zaragoza",
  "MX-COL": "Mexico - Colima",
  "MX-GRO": "Mexico - Guerrero",
  "MX-GUA": "Mexico - Guanajuato",
  "MX-JAL": "Mexico - Jalisco",
  "MX-MEX": "Mexico - México",
  "MX-MIC": "Mexico - Michoacán de Ocampo",
  "MX-MOR": "Mexico - Morelos",
  "MX-NAY": "Mexico - Nayarit",
  "MX-NLE": "Mexico - Nuevo León",
  "MX-OAX": "Mexico - Oaxaca",
  "MX-PUE": "Mexico - Puebla",
  "MX-ROO": "Mexico - Quintana Roo",
  "MX-SIN": "Mexico - Sinaloa",
  "MX-SLP": "Mexico - San Luis Potosí",
  "MX-SON": "Mexico - Sonora",
  "MX-TAB": "Mexico - Tabasco",
  "MX-TAM": "Mexico - Tamaulipas",
  "MX-TLA": "Mexico - Tlaxcala",
  "MX-VER": "Mexico - Veracruz de Ignacio de la Llave",
  "MX-YUC": "Mexico - Yucatán",
  "US-AK": "United States of America - Alaska",
  "US-AL": "United States of America - Alabama",
  "US-AR": "United States of America - Arkansas",
  "US-AZ": "United States of America - Arizona",
  "US-CA": "United States of America - California",
  "US-CO": "United States of America - Colorado",
  "US-CT": "United States of America - Connecticut",
  "US-DC": "United States of America - District of Columbia",
  "US-DE": "United States of America - Delaware",
  "US-FL": "United States of America - Florida",
  "US-GA": "United States of America - Georgia",
  // US-GU is not in Veridas list
  "US-GU": "United States of America - Guam",
  "US-HI": "United States of America - Hawaii",
  "US-IA": "United States of America - Iowa",
  "US-ID": "United States of America - Idaho",
  "US-IL": "United States of America - Illinois",
  "US-IN": "United States of America - Indiana",
  "US-KS": "United States of America - Kansas",
  "US-KY": "United States of America - Kentucky",
  "US-LA": "United States of America - Louisiana",
  "US-MA": "United States of America - Massachusetts",
  "US-MD": "United States of America - Maryland",
  "US-ME": "United States of America - Maine",
  "US-MI": "United States of America - Michigan",
  "US-MN": "United States of America - Minnesota",
  "US-MO": "United States of America - Missouri",
  "US-MS": "United States of America - Mississippi",
  "US-MT": "United States of America - Montana",
  "US-NC": "United States of America - North Carolina",
  "US-ND": "United States of America - North Dakota",
  "US-NE": "United States of America - Nebraska",
  "US-NH": "United States of America - New Hampshire",
  "US-NJ": "United States of America - New Jersey",
  "US-NM": "United States of America - New Mexico",
  "US-NV": "United States of America - Nevada",
  "US-NY": "United States of America - New York",
  "US-OH": "United States of America - Ohio",
  "US-OK": "United States of America - Oklahoma",
  "US-OR": "United States of America - Oregon",
  "US-PA": "United States of America - Pennsylvania",
  // US-PR is not in Veridas list
  "US-PR": "United States of America - Puerto Rico",
  "US-RI": "United States of America - Rhode Island",
  "US-SC": "United States of America - South Carolina",
  "US-SD": "United States of America - South Dakota",
  "US-TN": "United States of America - Tennessee",
  "US-TX": "United States of America - Texas",
  "US-UT": "United States of America - Utah",
  "US-VA": "United States of America - Virginia",
  "US-VT": "United States of America - Vermont",
  "US-WA": "United States of America - Washington",
  "US-WI": "United States of America - Wisconsin",
  "US-WV": "United States of America - West Virginia",
  "US-WY": "United States of America - Wyoming",
};
